/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 669:
/***/ (function(module) {

module.exports = jQuery;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/

;// ./src/js/components/algolia.js
/**
 * An <a role="button"> is announced as a button, so Space must activate it.
 * Links only respond to Enter natively; Space would scroll the page instead.
 */
function addSpaceActivation(el) {
  if (!el || el.getAttribute('role') !== 'button') return;
  el.addEventListener('keydown', function (e) {
    if (e.key === ' ' || e.key === 'Spacebar') {
      e.preventDefault();
      el.click();
    }
  });
}
function algolia() {
  console.log('algolia.js loaded');
  if (innerWidth > 768) {
    var searchBtn = document.querySelector('.header__search__button a[href="/search"]');
    if (searchBtn) {
      addSpaceActivation(searchBtn);
      searchBtn.addEventListener('click', function (e) {
        console.log('header search clicked');
        e.preventDefault();
        var self = this;
        if (self.classList.contains('active')) {
          var input = document.querySelector(".aa-MainContainer input");
          var value = input ? input.value : '';
          window.location.href = "/search?q=" + value;
        } else {
          self.classList.add('active');
          var searchContainer = self.parentElement ? self.parentElement.querySelector('.search-input-container') : null;
          if (searchContainer) searchContainer.classList.add('active');
          var aaInput = document.querySelector('.aa-MainContainer input');
          if (aaInput) aaInput.focus();
        }
      });
    }
  } else {
    document.querySelectorAll('.header__search__button a[href="/search"], #header-search svg').forEach(function (el) {
      addSpaceActivation(el);
      el.addEventListener('click', function (e) {
        console.log('header search clicked mobile');
        var detachedBtn = document.querySelector('.aa-MainContainer .aa-DetachedSearchButton');
        if (detachedBtn) {
          console.log('detached search button exists');
          e.preventDefault();
          detachedBtn.click();
        }
      });
    });
  }
}
;// ./src/js/components/cart-status-announcer.js
/**
 * Cart Status Announcer - Accessibility Enhancement
 * Announces cart actions to screen readers per WCAG 4.1.3 (Status Messages)
 *
 * Addresses: Paragraph 35(g) of accessibility report
 * - Announces when items are added to cart
 * - Provides cart count information
 * - Ensures screen reader users know the action was successful
 */

function cartStatusAnnouncer() {
  var announcementElement = null;
  var lastCartCount = 0;

  /**
   * Create or get the live region for announcements
   */
  function getAnnouncementElement() {
    if (announcementElement) {
      return announcementElement;
    }

    // Create a visually hidden live region
    announcementElement = document.createElement('div');
    announcementElement.setAttribute('role', 'status');
    announcementElement.setAttribute('aria-live', 'polite');
    announcementElement.setAttribute('aria-atomic', 'true');
    announcementElement.className = 'visually-hidden';
    announcementElement.id = 'cart-status-announcer';
    document.body.appendChild(announcementElement);
    return announcementElement;
  }

  /**
   * Announce a message to screen readers
   */
  function announce(message) {
    var element = getAnnouncementElement();

    // Clear previous message
    element.textContent = '';

    // Set new message after a brief delay to ensure screen readers pick it up
    setTimeout(function () {
      element.textContent = message;
      console.log('[Cart A11y]', message);
    }, 100);

    // Clear after announcement is read
    setTimeout(function () {
      element.textContent = '';
    }, 5000);
  }

  /**
   * Get current cart count
   */
  function getCartCount(cart) {
    if (!cart) return 0;
    return cart.item_count || 0;
  }

  /**
   * Handle cart change event
   */
  function handleCartChange(event) {
    var _event$detail;
    var cart = (_event$detail = event.detail) === null || _event$detail === void 0 ? void 0 : _event$detail.cart;
    if (!cart) return;
    var currentCount = getCartCount(cart);

    // If cart count increased, item was added
    if (currentCount > lastCartCount) {
      var itemsAdded = currentCount - lastCartCount;
      announceItemAdded(cart, itemsAdded);
    }
    // If cart count decreased, item was removed
    else if (currentCount < lastCartCount) {
      var itemsRemoved = lastCartCount - currentCount;
      announceItemRemoved(cart, itemsRemoved);
    }
    // If count is same but event fired, just announce current count
    else if (currentCount > 0) {
      announceCartUpdate(cart);
    }
    lastCartCount = currentCount;
  }

  /**
   * Announce item added to cart
   */
  function announceItemAdded(cart) {
    var _cart$items;
    var itemsAdded = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var totalItems = getCartCount(cart);
    var lastItem = (_cart$items = cart.items) === null || _cart$items === void 0 ? void 0 : _cart$items[cart.items.length - 1];
    var message = '';
    if (lastItem) {
      var productTitle = lastItem.product_title || 'Item';
      var variantTitle = lastItem.variant_title ? " - ".concat(lastItem.variant_title) : '';
      var quantity = lastItem.quantity || 1;
      if (quantity > 1) {
        message = "".concat(quantity, " ").concat(productTitle).concat(variantTitle, " added to cart. ");
      } else {
        message = "".concat(productTitle).concat(variantTitle, " added to cart. ");
      }
    } else if (itemsAdded > 1) {
      message = "".concat(itemsAdded, " items added to cart. ");
    } else {
      message = 'Item added to cart. ';
    }

    // Add cart count
    if (totalItems === 1) {
      message += 'You have 1 item in your cart.';
    } else {
      message += "You have ".concat(totalItems, " items in your cart.");
    }
    announce(message);
  }

  /**
   * Announce item removed from cart
   */
  function announceItemRemoved(cart) {
    var itemsRemoved = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var totalItems = getCartCount(cart);
    var message = '';
    if (itemsRemoved > 1) {
      message = "".concat(itemsRemoved, " items removed from cart. ");
    } else {
      message = 'Item removed from cart. ';
    }

    // Add cart count
    if (totalItems === 0) {
      message += 'Your cart is now empty.';
    } else if (totalItems === 1) {
      message += 'You have 1 item in your cart.';
    } else {
      message += "You have ".concat(totalItems, " items in your cart.");
    }
    announce(message);
  }

  /**
   * Announce cart update (quantity change or general update)
   */
  function announceCartUpdate(cart) {
    var totalItems = getCartCount(cart);
    var message = 'Cart updated. ';
    if (totalItems === 0) {
      message += 'Your cart is empty.';
    } else if (totalItems === 1) {
      message += 'You have 1 item in your cart.';
    } else {
      message += "You have ".concat(totalItems, " items in your cart.");
    }
    announce(message);
  }

  /**
   * Initialize the announcer
   */
  function init() {
    // Listen for cart change events
    document.addEventListener('theme:cart:change', handleCartChange);

    // Get initial cart count
    if (window.cart && window.cart.item_count !== undefined) {
      lastCartCount = window.cart.item_count;
    }
    console.log('[Cart A11y] Cart status announcer initialized');
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Return cleanup function
  return function () {
    document.removeEventListener('theme:cart:change', handleCartChange);
    if (announcementElement && announcementElement.parentNode) {
      announcementElement.parentNode.removeChild(announcementElement);
    }
  };
}
;// ./src/js/components/product-video-accessible.js
/**
 * Product Video Accessibility Enhancement
 * Ensures product videos are keyboard accessible and don't disappear on focus
 *
 * Addresses: WCAG 2.2.2 (Pause, Stop, Hide) and keyboard accessibility
 * - Makes videos and Plyr containers tabbable
 * - Adds aria-labels for screen readers
 * - Ensures videos remain visible when focused
 */

function productVideoAccessible() {
  /**
   * Enhance Plyr container (Shopify's video player wrapper)
   */
  function enhancePlyrContainer(plyrContainer) {
    // Mark this container as already processed
    if (plyrContainer.dataset.a11yEnhanced) return;
    plyrContainer.dataset.a11yEnhanced = 'true';

    // Add aria-label to the Plyr container
    if (!plyrContainer.hasAttribute('aria-label')) {
      var _document$querySelect, _document$querySelect2, _document$querySelect3;
      var productTitle = ((_document$querySelect = document.querySelector('[data-product-title]')) === null || _document$querySelect === void 0 || (_document$querySelect = _document$querySelect.textContent) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.trim()) || ((_document$querySelect2 = document.querySelector('.product__title')) === null || _document$querySelect2 === void 0 || (_document$querySelect2 = _document$querySelect2.textContent) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.trim()) || ((_document$querySelect3 = document.querySelector('h1')) === null || _document$querySelect3 === void 0 || (_document$querySelect3 = _document$querySelect3.textContent) === null || _document$querySelect3 === void 0 ? void 0 : _document$querySelect3.trim()) || 'Product';
      plyrContainer.setAttribute('aria-label', "Product video for ".concat(productTitle));
    }

    // Find all interactive controls inside Plyr
    var controls = plyrContainer.querySelectorAll('button, [role="slider"], input[type="range"], .plyr__control');
    controls.forEach(function (control) {
      // Remove any negative tabindex that would skip the control
      if (control.getAttribute('tabindex') === '-1') {
        control.removeAttribute('tabindex');
      }
      // Ensure control is tabbable
      control.setAttribute('tabindex', '0');
    });

    // Make the large play button overlay specifically focusable
    var playButtonOverlay = plyrContainer.querySelector('.plyr__control--overlaid');
    if (playButtonOverlay) {
      playButtonOverlay.setAttribute('tabindex', '0');
      if (!playButtonOverlay.hasAttribute('aria-label')) {
        playButtonOverlay.setAttribute('aria-label', 'Play video');
      }
    }

    // Make the play/pause button in controls focusable
    var playButton = plyrContainer.querySelector('[data-plyr="play"]');
    if (playButton) {
      playButton.setAttribute('tabindex', '0');
    }

    // Make progress/seek bar focusable
    var progressBar = plyrContainer.querySelector('.plyr__progress input[type="range"], [data-plyr="seek"]');
    if (progressBar) {
      progressBar.setAttribute('tabindex', '0');
      if (!progressBar.hasAttribute('aria-label')) {
        progressBar.setAttribute('aria-label', 'Seek');
      }
    }

    // Make volume control focusable
    var volumeControl = plyrContainer.querySelector('.plyr__volume input[type="range"], [data-plyr="volume"]');
    if (volumeControl) {
      volumeControl.setAttribute('tabindex', '0');
      if (!volumeControl.hasAttribute('aria-label')) {
        volumeControl.setAttribute('aria-label', 'Volume');
      }
    }

    // Make mute button focusable
    var muteButton = plyrContainer.querySelector('[data-plyr="mute"]');
    if (muteButton) {
      muteButton.setAttribute('tabindex', '0');
    }

    // Make fullscreen button focusable
    var fullscreenButton = plyrContainer.querySelector('[data-plyr="fullscreen"]');
    if (fullscreenButton) {
      fullscreenButton.setAttribute('tabindex', '0');
    }

    // Add keyboard focus tracking class for CSS targeting
    plyrContainer.addEventListener('focusin', function () {
      plyrContainer.classList.add('plyr-focused');
      plyrContainer.classList.add('plyr--keyboard-focus');

      // Make sure controls are visible
      var controlsContainer = plyrContainer.querySelector('.plyr__controls');
      if (controlsContainer) {
        controlsContainer.style.opacity = '1';
        controlsContainer.style.visibility = 'visible';
        controlsContainer.style.pointerEvents = 'auto';
      }
      var mediaSlide = plyrContainer.closest('[data-media-slide]');
      if (mediaSlide) {
        mediaSlide.classList.add('is-focused');
        mediaSlide.style.visibility = 'visible';
        mediaSlide.style.opacity = '1';
      }
    });
    plyrContainer.addEventListener('focusout', function (e) {
      // Only remove focus if focus is leaving the Plyr entirely
      if (!plyrContainer.contains(e.relatedTarget)) {
        plyrContainer.classList.remove('plyr-focused');
        plyrContainer.classList.remove('plyr--keyboard-focus');
        var mediaSlide = plyrContainer.closest('[data-media-slide]');
        if (mediaSlide) {
          mediaSlide.classList.remove('is-focused');
        }
      }
    });
    var controlCount = controls.length;
    console.log('[Video A11y] Enhanced Plyr container with', controlCount, 'controls');
  }

  /**
   * Enhance a video element with accessibility attributes
   */
  function enhanceVideo(video, container) {
    // Check if video is wrapped by Plyr
    var plyrContainer = video.closest('.plyr');
    if (plyrContainer) {
      enhancePlyrContainer(plyrContainer);
      return; // Plyr handles its own controls
    }

    // Make video tabbable
    if (!video.hasAttribute('tabindex')) {
      video.setAttribute('tabindex', '0');
    }

    // Add aria-label if not present
    if (!video.hasAttribute('aria-label')) {
      var _document$querySelect4, _document$querySelect5, _document$querySelect6;
      var productTitle = ((_document$querySelect4 = document.querySelector('[data-product-title]')) === null || _document$querySelect4 === void 0 || (_document$querySelect4 = _document$querySelect4.textContent) === null || _document$querySelect4 === void 0 ? void 0 : _document$querySelect4.trim()) || ((_document$querySelect5 = document.querySelector('.product__title')) === null || _document$querySelect5 === void 0 || (_document$querySelect5 = _document$querySelect5.textContent) === null || _document$querySelect5 === void 0 ? void 0 : _document$querySelect5.trim()) || ((_document$querySelect6 = document.querySelector('h1')) === null || _document$querySelect6 === void 0 || (_document$querySelect6 = _document$querySelect6.textContent) === null || _document$querySelect6 === void 0 ? void 0 : _document$querySelect6.trim()) || 'Product';
      video.setAttribute('aria-label', "Product video for ".concat(productTitle, ". Use space to play or pause."));
    }

    // Ensure video container stays visible on focus
    if (container) {
      container.classList.add('video-accessible');
    }

    // Add focus indicator for keyboard users
    video.addEventListener('focus', function () {
      video.classList.add('video-focused');
      var mediaSlide = video.closest('[data-media-slide]');
      if (mediaSlide) {
        mediaSlide.classList.add('is-focused');
        mediaSlide.style.visibility = 'visible';
        mediaSlide.style.opacity = '1';
      }
    });
    video.addEventListener('blur', function () {
      video.classList.remove('video-focused');
      var mediaSlide = video.closest('[data-media-slide]');
      if (mediaSlide) {
        mediaSlide.classList.remove('is-focused');
      }
    });

    // Add keyboard controls for native video
    video.addEventListener('keydown', function (event) {
      switch (event.key) {
        case ' ':
        case 'Enter':
          event.preventDefault();
          if (video.paused) {
            video.play();
          } else {
            video.pause();
          }
          break;
        case 'ArrowLeft':
          event.preventDefault();
          video.currentTime = Math.max(0, video.currentTime - 5);
          break;
        case 'ArrowRight':
          event.preventDefault();
          video.currentTime = Math.min(video.duration, video.currentTime + 5);
          break;
        case 'm':
        case 'M':
          event.preventDefault();
          video.muted = !video.muted;
          break;
      }
    });
  }

  /**
   * Enhance iframe embeds (YouTube, Vimeo)
   */
  function enhanceIframe(iframe, container) {
    if (!iframe.hasAttribute('tabindex')) {
      iframe.setAttribute('tabindex', '0');
    }
    if (!iframe.hasAttribute('title')) {
      var _document$querySelect7, _document$querySelect8;
      var productTitle = ((_document$querySelect7 = document.querySelector('[data-product-title]')) === null || _document$querySelect7 === void 0 || (_document$querySelect7 = _document$querySelect7.textContent) === null || _document$querySelect7 === void 0 ? void 0 : _document$querySelect7.trim()) || ((_document$querySelect8 = document.querySelector('.product__title')) === null || _document$querySelect8 === void 0 || (_document$querySelect8 = _document$querySelect8.textContent) === null || _document$querySelect8 === void 0 ? void 0 : _document$querySelect8.trim()) || 'Product';
      iframe.setAttribute('title', "Product video for ".concat(productTitle));
    }
    if (container) {
      container.classList.add('video-accessible');
    }
    iframe.addEventListener('focus', function () {
      var mediaSlide = iframe.closest('[data-media-slide]');
      if (mediaSlide) {
        mediaSlide.classList.add('is-focused');
        mediaSlide.style.visibility = 'visible';
        mediaSlide.style.opacity = '1';
      }
    });
    iframe.addEventListener('blur', function () {
      var mediaSlide = iframe.closest('[data-media-slide]');
      if (mediaSlide) {
        mediaSlide.classList.remove('is-focused');
      }
    });
  }

  /**
   * Setup focus management for video media slides
   * When user tabs to the video container, allow them to tab into Plyr controls
   */
  function setupVideoSlideKeyboardNav(mediaSlide) {
    if (mediaSlide.dataset.keyboardNavSetup) return;
    mediaSlide.dataset.keyboardNavSetup = 'true';
    mediaSlide.addEventListener('keydown', function (e) {
      // When Tab is pressed on the container itself, move focus into Plyr controls
      if (e.key === 'Tab' && !e.shiftKey && e.target === mediaSlide) {
        var plyr = mediaSlide.querySelector('.plyr');
        if (plyr) {
          // Find the first focusable element inside Plyr
          var firstFocusable = plyr.querySelector('.plyr__control--overlaid, [data-plyr="play"], .plyr__controls button, .plyr__controls input');
          if (firstFocusable) {
            e.preventDefault();
            firstFocusable.focus();
          }
        }
      }

      // Space or Enter on the container should play/pause
      if ((e.key === ' ' || e.key === 'Enter') && e.target === mediaSlide) {
        e.preventDefault();
        var playButton = mediaSlide.querySelector('.plyr__control--overlaid, [data-plyr="play"]');
        if (playButton) {
          playButton.click();
        } else {
          var video = mediaSlide.querySelector('video');
          if (video) {
            if (video.paused) {
              video.play();
            } else {
              video.pause();
            }
          }
        }
      }
    });
  }

  /**
   * Initialize video accessibility
   */
  function init() {
    // Find all Plyr containers (Shopify's video player)
    var plyrContainers = document.querySelectorAll('.plyr');
    plyrContainers.forEach(function (plyr) {
      // enhancePlyrContainer handles its own duplicate check via data attribute
      enhancePlyrContainer(plyr);
    });

    // Setup keyboard nav for video media slides
    var videoSlides = document.querySelectorAll('.product__media--video, [data-media-slide][data-type="video"], [data-media-slide][data-type="external_video"]');
    videoSlides.forEach(function (slide) {
      setupVideoSlideKeyboardNav(slide);
    });

    // Find all video containers
    var videoContainers = document.querySelectorAll('[data-video-container]');
    videoContainers.forEach(function (container) {
      var video = container.querySelector('video');
      if (video) {
        enhanceVideo(video, container);
      }
      var iframe = container.querySelector('iframe');
      if (iframe) {
        enhanceIframe(iframe, container);
      }
    });

    // Also find any videos that might not be in our containers
    var allVideos = document.querySelectorAll('.product__media video, .product__media__wrapper video');
    allVideos.forEach(function (video) {
      enhanceVideo(video, video.closest('.media__contain'));
    });

    // Log initialization
    var plyrCount = document.querySelectorAll('.plyr[data-a11y-enhanced]').length;
    var videoCount = document.querySelectorAll('video[tabindex]').length;
    if (plyrCount > 0 || videoCount > 0) {
      console.log('[Video A11y] Enhanced', plyrCount, 'Plyr players and', videoCount, 'native videos');
    }
  }

  /**
   * Watch for Plyr controls to be added to the DOM
   */
  function watchForPlyrControls() {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) {
            var _node$classList, _node$querySelector, _node$classList2, _node$querySelector2;
            // Element node
            // Check if this is a Plyr container or contains Plyr controls
            if ((_node$classList = node.classList) !== null && _node$classList !== void 0 && _node$classList.contains('plyr') || (_node$querySelector = node.querySelector) !== null && _node$querySelector !== void 0 && _node$querySelector.call(node, '.plyr')) {
              console.log('[Video A11y] Plyr detected, enhancing controls...');
              setTimeout(init, 100); // Small delay to ensure controls are rendered
            }
            // Check if Plyr controls were added
            if ((_node$classList2 = node.classList) !== null && _node$classList2 !== void 0 && _node$classList2.contains('plyr__controls') || (_node$querySelector2 = node.querySelector) !== null && _node$querySelector2 !== void 0 && _node$querySelector2.call(node, '.plyr__controls')) {
              console.log('[Video A11y] Plyr controls detected, making them tabbable...');
              setTimeout(init, 100);
            }
          }
        });
      });
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    return observer;
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
      watchForPlyrControls();
    });
  } else {
    init();
    watchForPlyrControls();
  }

  // Re-initialize after delays to catch Plyr loading
  setTimeout(init, 500);
  setTimeout(init, 1000);
  setTimeout(init, 2000);
  setTimeout(init, 3000);

  // Re-initialize when product media changes
  document.addEventListener('theme:media:change', init);

  // Re-initialize when video starts playing (Plyr might render controls then)
  document.addEventListener('play', function (e) {
    if (e.target.tagName === 'VIDEO') {
      setTimeout(init, 100);
    }
  }, true);
}
;// ./src/js/sections/collection-tabs-accessible.js
/**
 * Collection Tabs Carousel Accessibility
 * Ensures Flickity carousels are keyboard accessible and properly announced
 *
 * Addresses:
 * - WCAG 2.1.1 (Keyboard) - All functionality available via keyboard
 * - WCAG 4.1.2 (Name, Role, Value) - Proper ARIA labels and roles
 * - Carousel navigation controls operable with keyboard
 * - Screen reader announcements for slide changes
 */

function collectionTabsAccessible() {
  var SELECTORS = {
    section: '[data-section-type="collection-tabs"]',
    carousel: '[data-carousel]',
    flickityButton: '.flickity-button',
    flickityPrevButton: '.flickity-button.previous',
    flickityNextButton: '.flickity-button.next',
    customPrevButton: '[data-carousel-prev]',
    customNextButton: '[data-carousel-next]',
    navControls: '.carousel-nav-controls',
    slide: '[data-carousel-slide]',
    statusRegion: '[data-carousel-status]',
    tabContent: '.tab-content',
    flickityCarousel: 'flickity-carousel'
  };

  /**
   * Move Flickity buttons to the beginning of the container for proper tab order
   * This ensures prev/next buttons are tabbable BEFORE the carousel content
   */
  function moveFlickityButtonsToStart(container) {
    var carousel = container.querySelector(SELECTORS.carousel);
    if (!carousel) return;
    var prevButton = container.querySelector(SELECTORS.flickityPrevButton);
    var nextButton = container.querySelector(SELECTORS.flickityNextButton);
    if (!prevButton || !nextButton) return;

    // Skip if already moved
    if (prevButton.dataset.a11yMoved) return;
    prevButton.dataset.a11yMoved = 'true';
    nextButton.dataset.a11yMoved = 'true';

    // Create a wrapper for the buttons at the start
    var buttonWrapper = document.createElement('div');
    buttonWrapper.className = 'flickity-nav-wrapper';
    buttonWrapper.setAttribute('aria-label', 'Carousel navigation');

    // Move buttons into wrapper
    buttonWrapper.appendChild(prevButton);
    buttonWrapper.appendChild(nextButton);

    // Insert wrapper at the beginning of the container (before carousel)
    container.insertBefore(buttonWrapper, container.firstChild);

    // Enhance buttons with proper accessibility
    enhanceFlickityButtons(container, carousel);
  }

  /**
   * Enhance Flickity buttons with proper accessibility attributes
   */
  function enhanceFlickityButtons(container, carousel) {
    var prevButton = container.querySelector(SELECTORS.flickityPrevButton);
    var nextButton = container.querySelector(SELECTORS.flickityNextButton);
    var carouselLabel = (carousel === null || carousel === void 0 ? void 0 : carousel.getAttribute('aria-label')) || 'Product carousel';
    if (prevButton) {
      prevButton.setAttribute('tabindex', '0');
      prevButton.setAttribute('aria-label', "Previous slide in ".concat(carouselLabel));

      // Add focus indicator class
      prevButton.addEventListener('focus', function () {
        prevButton.classList.add('flickity-button--focused');
      });
      prevButton.addEventListener('blur', function () {
        prevButton.classList.remove('flickity-button--focused');
      });
    }
    if (nextButton) {
      nextButton.setAttribute('tabindex', '0');
      nextButton.setAttribute('aria-label', "Next slide in ".concat(carouselLabel));
      nextButton.addEventListener('focus', function () {
        nextButton.classList.add('flickity-button--focused');
      });
      nextButton.addEventListener('blur', function () {
        nextButton.classList.remove('flickity-button--focused');
      });
    }
  }

  /**
   * Update the live region with current slide information
   */
  function updateSlideStatus(carousel, currentIndex, totalSlides) {
    var statusRegion = carousel.querySelector(SELECTORS.statusRegion);
    if (statusRegion) {
      var currentSlide = carousel.querySelectorAll(SELECTORS.slide)[currentIndex];
      var slideLabel = (currentSlide === null || currentSlide === void 0 ? void 0 : currentSlide.getAttribute('aria-label')) || "Slide ".concat(currentIndex + 1);
      statusRegion.textContent = "".concat(slideLabel, " of ").concat(totalSlides);
    }
  }

  /**
   * Add keyboard navigation for the carousel
   */
  function addKeyboardNavigation(carousel) {
    carousel.addEventListener('keydown', function (e) {
      var prevButton = carousel.querySelector(SELECTORS.prevButton);
      var nextButton = carousel.querySelector(SELECTORS.nextButton);
      switch (e.key) {
        case 'ArrowLeft':
          if (prevButton && !prevButton.disabled) {
            e.preventDefault();
            prevButton.click();
            prevButton.focus();
          }
          break;
        case 'ArrowRight':
          if (nextButton && !nextButton.disabled) {
            e.preventDefault();
            nextButton.click();
            nextButton.focus();
          }
          break;
        case 'Home':
          // Go to first slide
          e.preventDefault();
          if (prevButton) {
            // Click prev until at beginning or use Flickity API
            var _flickityInstance = getFlickityInstance(carousel);
            if (_flickityInstance) {
              _flickityInstance.select(0);
            }
          }
          break;
        case 'End':
          // Go to last slide
          e.preventDefault();
          var flickityInstance = getFlickityInstance(carousel);
          if (flickityInstance && flickityInstance.slides) {
            flickityInstance.select(flickityInstance.slides.length - 1);
          }
          break;
      }
    });
  }

  /**
   * Get the Flickity instance from a carousel element
   */
  function getFlickityInstance(carousel) {
    // Flickity stores the instance on the element
    return carousel.flickityInstance || window.Flickity && window.Flickity.data(carousel) || null;
  }

  /**
   * Watch for Flickity to initialize and enhance it
   */
  function watchForFlickity(carousel, container) {
    // Flickity adds 'flickity-enabled' class when initialized
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (carousel.classList.contains('flickity-enabled')) {
            setTimeout(function () {
              moveFlickityButtonsToStart(container);
              setupSlideChangeListener(carousel);
            }, 100);
          }
        }
      });
    });
    observer.observe(carousel, {
      attributes: true
    });

    // Also check if already initialized
    if (carousel.classList.contains('flickity-enabled')) {
      setTimeout(function () {
        moveFlickityButtonsToStart(container);
        setupSlideChangeListener(carousel);
      }, 100);
    }
    return observer;
  }

  /**
   * Listen for slide changes and update status
   */
  function setupSlideChangeListener(carousel) {
    var flickityInstance = getFlickityInstance(carousel);
    var slides = carousel.querySelectorAll(SELECTORS.slide);
    if (flickityInstance) {
      flickityInstance.on('change', function (index) {
        updateSlideStatus(carousel, index, slides.length);
      });
    }
  }

  /**
   * Initialize accessibility for all collection tabs carousels
   */
  function init() {
    var sections = document.querySelectorAll(SELECTORS.section);
    sections.forEach(function (section) {
      // Find all flickity-carousel containers
      var flickityContainers = section.querySelectorAll(SELECTORS.flickityCarousel);
      flickityContainers.forEach(function (container) {
        var carousel = container.querySelector(SELECTORS.carousel);
        if (!carousel) return;

        // Skip if already enhanced
        if (carousel.dataset.a11yEnhanced) return;
        carousel.dataset.a11yEnhanced = 'true';

        // Add keyboard navigation
        addKeyboardNavigation(carousel);

        // Watch for Flickity initialization and wire up custom buttons
        watchForFlickity(carousel, container);

        // Initialize slide status
        var slides = carousel.querySelectorAll(SELECTORS.slide);
        if (slides.length > 0) {
          updateSlideStatus(carousel, 0, slides.length);
        }
      });
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize after delays for dynamic content
  setTimeout(init, 500);
  setTimeout(init, 1000);

  // Re-initialize when tabs change
  document.addEventListener('click', function (e) {
    if (e.target.closest('.tab-link')) {
      setTimeout(init, 200);
    }
  });
}
;// ./src/js/components/nav-dropdown-accessible.js
/**
 * Navigation Dropdown Accessibility Enhancement
 * Adds proper button functionality for navigation items with submenus
 *
 * Addresses: WCAG 2.1 Level AA - Navigation button semantics
 * - Separates navigation links from dropdown controls
 * - Provides proper aria-expanded state management
 * - Ensures keyboard accessibility for dropdown buttons
 * - Syncs aria-expanded with hover disclosure system
 */

function navDropdownAccessible() {
  var dropdownButtons = document.querySelectorAll('[data-dropdown-toggle]');
  if (!dropdownButtons.length) {
    return;
  }

  /**
   * Update aria-expanded state on a button
   */
  function setExpandedState(button, expanded) {
    button.setAttribute('aria-expanded', expanded.toString());
  }

  /**
   * Toggle dropdown state for a button
   */
  function toggleDropdown(button) {
    var currentState = button.getAttribute('aria-expanded') === 'true';
    var newState = !currentState;
    setExpandedState(button, newState);

    // Get the dropdown ID from aria-controls
    var dropdownId = button.getAttribute('aria-controls');
    var dropdown = document.getElementById(dropdownId);
    if (dropdown) {
      // Trigger the existing hover disclosure system
      var menuItem = button.closest('.menu__item');
      if (menuItem) {
        if (newState) {
          // Show dropdown
          menuItem.classList.add('is-visible');
          dropdown.classList.add('is-visible');
        } else {
          // Hide dropdown
          menuItem.classList.remove('is-visible');
          dropdown.classList.remove('is-visible');
        }
      }
    }
  }

  /**
   * Sync aria-expanded with hover state
   */
  function syncWithHoverState(button, menuItem) {
    // Update on mouseenter
    menuItem.addEventListener('mouseenter', function () {
      setExpandedState(button, true);
    });

    // Update on mouseleave
    menuItem.addEventListener('mouseleave', function () {
      setExpandedState(button, false);
    });

    // Also watch for class changes (in case hover disclosure uses other methods)
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.attributeName === 'class') {
          var isVisible = menuItem.classList.contains('is-visible');
          setExpandedState(button, isVisible);
        }
      });
    });
    observer.observe(menuItem, {
      attributes: true,
      attributeFilter: ['class']
    });
    return observer;
  }

  /**
   * Close dropdown when clicking outside
   */
  function handleOutsideClick(event) {
    dropdownButtons.forEach(function (button) {
      var expanded = button.getAttribute('aria-expanded') === 'true';
      if (expanded) {
        var menuItem = button.closest('.menu__item');
        var clickedInside = menuItem && menuItem.contains(event.target);
        if (!clickedInside) {
          setExpandedState(button, false);
          menuItem.classList.remove('is-visible');
          var dropdownId = button.getAttribute('aria-controls');
          var dropdown = document.getElementById(dropdownId);
          if (dropdown) {
            dropdown.classList.remove('is-visible');
          }
        }
      }
    });
  }

  /**
   * Close dropdown on Escape key
   */
  function handleEscape(event) {
    if (event.key === 'Escape' || event.keyCode === 27) {
      dropdownButtons.forEach(function (button) {
        var expanded = button.getAttribute('aria-expanded') === 'true';
        if (expanded) {
          setExpandedState(button, false);
          var menuItem = button.closest('.menu__item');
          if (menuItem) {
            menuItem.classList.remove('is-visible');
          }
          var dropdownId = button.getAttribute('aria-controls');
          var dropdown = document.getElementById(dropdownId);
          if (dropdown) {
            dropdown.classList.remove('is-visible');
          }

          // Return focus to button
          button.focus();
        }
      });
    }
  }

  /**
   * Initialize dropdown buttons
   */
  var observers = [];
  function init() {
    dropdownButtons.forEach(function (button) {
      var menuItem = button.closest('.menu__item');

      // Sync aria-expanded with hover state
      if (menuItem) {
        var observer = syncWithHoverState(button, menuItem);
        observers.push(observer);
      }

      // Add click handlers to buttons
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        toggleDropdown(button);
      });

      // Add keyboard support (Enter/Space)
      button.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ' || event.keyCode === 13 || event.keyCode === 32) {
          event.preventDefault();
          toggleDropdown(button);
        }
      });
    });

    // Close dropdowns when clicking outside
    document.addEventListener('click', handleOutsideClick);

    // Close dropdowns on Escape key
    document.addEventListener('keydown', handleEscape);
  }

  // Initialize
  init();

  // Return cleanup function
  return function () {
    document.removeEventListener('click', handleOutsideClick);
    document.removeEventListener('keydown', handleEscape);
    observers.forEach(function (observer) {
      return observer.disconnect();
    });
  };
}
;// ./src/js/components/carousel-accessibility.js
/* provided dependency */ var app_jQuery = __webpack_require__(669);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Carousel Accessibility - ARIA Live Region Announcements
 * Announces slide changes for screen reader users
 * Addresses AMP105 accessibility requirement
 */
var CarouselAccessibility = /*#__PURE__*/function () {
  function CarouselAccessibility() {
    _classCallCheck(this, CarouselAccessibility);
    this.init();
  }
  return _createClass(CarouselAccessibility, [{
    key: "init",
    value: function init() {
      this.initFlickityAnnouncements();
      this.initPhotoSwipeAnnouncements();
    }

    /**
     * Get or create the live region element
     */
  }, {
    key: "getLiveRegion",
    value: function getLiveRegion() {
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'carousel-live-region';
      var liveRegion = document.getElementById(id);

      // Create if doesn't exist
      if (!liveRegion) {
        liveRegion = document.createElement('div');
        liveRegion.id = id;
        liveRegion.className = 'visually-hidden';
        liveRegion.setAttribute('aria-live', 'polite');
        liveRegion.setAttribute('aria-atomic', 'true');
        document.body.appendChild(liveRegion);
      }
      return liveRegion;
    }

    /**
     * Announce message to screen readers via live region
     */
  }, {
    key: "announce",
    value: function announce(message) {
      var regionId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'carousel-live-region';
      var liveRegion = this.getLiveRegion(regionId);

      // Clear and set message (ensures announcement even if same text)
      liveRegion.textContent = '';
      setTimeout(function () {
        liveRegion.textContent = message;
      }, 100);
    }

    /**
     * Initialize Flickity carousel announcements
     */
  }, {
    key: "initFlickityAnnouncements",
    value: function initFlickityAnnouncements() {
      var _this = this;
      // Listen for click on Flickity navigation buttons
      document.addEventListener('click', function (e) {
        var prevBtn = e.target.closest('.flickity-prev-next-button.previous, [data-scrollbar-arrow-prev], .tabs__arrow--prev, .flickity-button.previous');
        var nextBtn = e.target.closest('.flickity-prev-next-button.next, [data-scrollbar-arrow-next], .tabs__arrow--next, .flickity-button.next');
        if (prevBtn || nextBtn) {
          setTimeout(function () {
            _this.announceFlickitySlide(e.target);
          }, 200);
        }
      });

      // Listen for keyboard navigation on Flickity carousels
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;

        // Check if focus is within a Flickity carousel
        var flickityContainer = e.target.closest('.flickity-enabled, flickity-carousel');
        if (flickityContainer) {
          setTimeout(function () {
            _this.announceFlickitySlide(flickityContainer);
          }, 200);
        }
      });

      // Watch for Flickity initialization and attach change listeners
      this.observeFlickityInit();
    }

    /**
     * Watch for Flickity carousels being initialized
     */
  }, {
    key: "observeFlickityInit",
    value: function observeFlickityInit() {
      var _this2 = this;
      // Initial check for existing carousels
      this.attachFlickityListeners();

      // Use MutationObserver to watch for new carousels
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            if (mutation.target.classList.contains('flickity-enabled')) {
              _this2.attachFlickityListener(mutation.target);
            }
          }
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach(function (node) {
              if (node.nodeType === 1) {
                var flickityElements = node.querySelectorAll ? node.querySelectorAll('.flickity-enabled') : [];
                flickityElements.forEach(function (el) {
                  return _this2.attachFlickityListener(el);
                });
                if (node.classList && node.classList.contains('flickity-enabled')) {
                  _this2.attachFlickityListener(node);
                }
              }
            });
          }
        });
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });
    }

    /**
     * Attach listeners to all existing Flickity carousels
     */
  }, {
    key: "attachFlickityListeners",
    value: function attachFlickityListeners() {
      var _this3 = this;
      // Wait a bit for Flickity to fully initialize
      setTimeout(function () {
        var flickityElements = document.querySelectorAll('.flickity-enabled');
        flickityElements.forEach(function (el) {
          return _this3.attachFlickityListener(el);
        });
      }, 1500);
    }

    /**
     * Attach change listener to a single Flickity instance
     */
  }, {
    key: "attachFlickityListener",
    value: function attachFlickityListener(element) {
      var _this4 = this;
      // Skip if already attached
      if (element.dataset.a11yAttached) return;
      element.dataset.a11yAttached = 'true';

      // Try to get Flickity instance
      var flickityInstance = this.getFlickityInstance(element);
      if (flickityInstance) {
        this.applyCarouselSemantics(element, flickityInstance);
        flickityInstance.on('change', function (index) {
          var totalSlides = flickityInstance.slides ? flickityInstance.slides.length : flickityInstance.cells.length;
          var message = "Showing slide ".concat(index + 1, " of ").concat(totalSlides);
          _this4.announce(message);
        });

        // Off-screen cells stay in the tab order and in the a11y tree unless we
        // take them out, so keyboard users tab into slides they cannot see.
        var syncCells = function syncCells() {
          return _this4.syncCellVisibility(element, flickityInstance);
        };
        flickityInstance.on('select', syncCells);
        flickityInstance.on('settle', syncCells);
        window.addEventListener('resize', syncCells);
        syncCells();
      }
    }

    /**
     * Give a Flickity carousel and its cells the roles the WAI-ARIA carousel pattern
     * expects. Applied here rather than per-template because these carousels come from
     * several places — theme sections, and Nosto-injected recommendation slots whose
     * markup we do not author — but all of them run through this component.
     *
     * Every attribute is set only when absent, so a template that already declares its
     * own semantics (sections/collection.liquid does) is never overwritten.
     */
  }, {
    key: "applyCarouselSemantics",
    value: function applyCarouselSemantics(element, flickityInstance) {
      if (!element.getAttribute('role')) {
        element.setAttribute('role', 'group');
      }
      if (!element.getAttribute('aria-roledescription')) {
        element.setAttribute('aria-roledescription', 'carousel');
      }
      if (!element.getAttribute('aria-label') && !element.getAttribute('aria-labelledby')) {
        // aria-roledescription already supplies the word "carousel", so the label must not.
        element.setAttribute('aria-label', this.nearestHeading(element) || 'Products');
      }
      var cells = flickityInstance.cells || [];
      cells.forEach(function (cell, index) {
        var el = cell.element;
        if (!el) return;
        if (!el.getAttribute('role')) {
          el.setAttribute('role', 'group');
        }
        if (!el.getAttribute('aria-roledescription')) {
          el.setAttribute('aria-roledescription', 'slide');
        }
        if (!el.getAttribute('aria-label') && !el.getAttribute('aria-labelledby')) {
          // Positional rather than content-derived: Nosto swaps each cell's contents in
          // after its own fetch, so reading a product title here would often run too early.
          el.setAttribute('aria-label', "".concat(index + 1, " of ").concat(cells.length));
        }
      });
    }

    /**
     * Closest heading that is not itself inside the carousel — product titles within the
     * slides are headings too, and would otherwise be picked up as the carousel's name.
     */
  }, {
    key: "nearestHeading",
    value: function nearestHeading(element) {
      var node = element.parentElement;
      while (node && node !== document.body) {
        var headings = node.querySelectorAll('h1, h2, h3, h4');
        for (var i = 0; i < headings.length; i += 1) {
          var heading = headings[i];
          var text = heading.textContent.trim().replace(/\s+/g, ' ');
          if (text && !element.contains(heading)) return text.slice(0, 80);
        }
        node = node.parentElement;
      }
      return '';
    }

    /**
     * Hide cells that are scrolled out of the viewport from both the tab order
     * and assistive tech, and mark the selected cell with aria-current.
     *
     * Visibility is measured geometrically rather than from selectedIndex, because
     * these carousels show several cells at once.
     */
  }, {
    key: "syncCellVisibility",
    value: function syncCellVisibility(element, flickityInstance) {
      var viewport = element.querySelector('.flickity-viewport');
      if (!viewport || !flickityInstance.cells) return;
      var bounds = viewport.getBoundingClientRect();
      if (!bounds.width) return;
      flickityInstance.cells.forEach(function (cell, index) {
        var el = cell.element;
        if (!el) return;
        var rect = el.getBoundingClientRect();
        // Tolerate a sub-pixel sliver so a cell flush with the edge still counts.
        var visible = rect.right > bounds.left + 1 && rect.left < bounds.right - 1;

        // Never hide the subtree that currently holds focus.
        var holdsFocus = el.contains(document.activeElement);
        if (visible || holdsFocus) {
          el.removeAttribute('aria-hidden');
        } else {
          el.setAttribute('aria-hidden', 'true');
        }
        el.querySelectorAll('a[href], button, input, select, textarea, [tabindex]').forEach(function (focusable) {
          if (visible || holdsFocus) {
            if (focusable.dataset.a11yTabindex === 'managed') {
              focusable.removeAttribute('tabindex');
              delete focusable.dataset.a11yTabindex;
            }
          } else if (focusable.getAttribute('tabindex') !== '-1') {
            focusable.dataset.a11yTabindex = 'managed';
            focusable.setAttribute('tabindex', '-1');
          }
        });
        if (index === flickityInstance.selectedIndex) {
          el.setAttribute('aria-current', 'true');
        } else {
          el.removeAttribute('aria-current');
        }
      });
    }

    /**
     * Get Flickity instance from element
     */
  }, {
    key: "getFlickityInstance",
    value: function getFlickityInstance(element) {
      // Try global Flickity.data method
      if (typeof Flickity !== 'undefined' && Flickity.data) {
        return Flickity.data(element);
      }

      // Try jQuery data
      if (typeof app_jQuery !== 'undefined') {
        var $el = app_jQuery(element);
        if ($el.data('flickity')) {
          return $el.data('flickity');
        }
      }

      // Try element's flickity property (set by some implementations)
      if (element.flickity) {
        return element.flickity;
      }
      return null;
    }

    /**
     * Get current slide info and announce
     */
  }, {
    key: "announceFlickitySlide",
    value: function announceFlickitySlide(targetElement) {
      // Find the Flickity container
      var carousel = targetElement.closest('flickity-carousel, .flickity-enabled') || targetElement.querySelector('.flickity-enabled');
      if (!carousel) return;
      var flickityEl = carousel.classList.contains('flickity-enabled') ? carousel : carousel.querySelector('.flickity-enabled');
      if (!flickityEl) return;
      var flickityInstance = this.getFlickityInstance(flickityEl);
      if (flickityInstance) {
        var currentIndex = flickityInstance.selectedIndex + 1;
        var totalSlides = flickityInstance.slides ? flickityInstance.slides.length : flickityInstance.cells.length;
        var message = "Showing slide ".concat(currentIndex, " of ").concat(totalSlides);
        this.announce(message);
      } else {
        // Fallback: try to get info from DOM
        var selectedSlide = flickityEl.querySelector('.is-selected');
        var allSlides = flickityEl.querySelectorAll('.flickity-slider > *');
        if (selectedSlide && allSlides.length) {
          var _currentIndex = Array.from(allSlides).indexOf(selectedSlide) + 1;
          var _message = "Showing slide ".concat(_currentIndex, " of ").concat(allSlides.length);
          this.announce(_message);
        }
      }
    }

    /**
     * Initialize PhotoSwipe lightbox announcements
     */
  }, {
    key: "initPhotoSwipeAnnouncements",
    value: function initPhotoSwipeAnnouncements() {
      var _this5 = this;
      // PhotoSwipe button clicks
      document.addEventListener('click', function (e) {
        var pswpPrev = e.target.closest('.pswp__button--arrow--left');
        var pswpNext = e.target.closest('.pswp__button--arrow--right');
        if (pswpPrev || pswpNext) {
          setTimeout(function () {
            _this5.announcePhotoSwipeSlide();
          }, 300);
        }
      });

      // Keyboard navigation in PhotoSwipe
      document.addEventListener('keydown', function (e) {
        var pswpOpen = document.querySelector('.pswp--open, .pswp--visible');
        if (pswpOpen && (e.key === 'ArrowLeft' || e.key === 'ArrowRight')) {
          setTimeout(function () {
            _this5.announcePhotoSwipeSlide();
          }, 300);
        }
      });

      // Also watch for PhotoSwipe opening and announce initial slide
      this.observePhotoSwipeOpen();
    }

    /**
     * Watch for PhotoSwipe opening
     */
  }, {
    key: "observePhotoSwipeOpen",
    value: function observePhotoSwipeOpen() {
      var _this6 = this;
      var pswpElement = document.querySelector('.pswp');
      if (!pswpElement) return;
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.attributeName === 'class') {
            var isOpen = pswpElement.classList.contains('pswp--open') || pswpElement.classList.contains('pswp--visible');
            if (isOpen) {
              // Announce initial slide when lightbox opens
              setTimeout(function () {
                _this6.announcePhotoSwipeSlide();
              }, 500);
            }
          }
        });
      });
      observer.observe(pswpElement, {
        attributes: true,
        attributeFilter: ['class']
      });
    }

    /**
     * Announce PhotoSwipe slide change
     */
  }, {
    key: "announcePhotoSwipeSlide",
    value: function announcePhotoSwipeSlide() {
      var counter = document.querySelector('.pswp__counter');
      var liveRegion = this.getLiveRegion('pswp-live-region');
      if (counter && counter.textContent) {
        // Counter format is typically "1 / 5"
        var counterText = counter.textContent.trim();
        if (counterText) {
          var message = "Image ".concat(counterText.replace('/', 'of'));

          // Clear then set to ensure announcement
          liveRegion.textContent = '';
          setTimeout(function () {
            liveRegion.textContent = message;
          }, 100);
        }
      }
    }
  }]);
}();
/* harmony default export */ var carousel_accessibility = (CarouselAccessibility);
;// ./src/js/components/collection-filter-accessibility.js
/**
 * AMP64: Collection Filter Accessibility
 * Announces filter changes to screen readers via live region
 */

var SELECTORS = {
  filterForm: '[data-sidebar-filter-form]',
  filterContainer: '.sidebar__filter__group, .collection__filters',
  filterCheckbox: '.filter__button input[type="checkbox"], .swatch__button input[type="checkbox"]',
  filterLiveRegion: '[data-filter-live-region]',
  productsCount: '[data-products-count]',
  countValue: '[data-count-value]',
  activeFilters: '[data-active-filters]'
};

/**
 * Get the current product count from the page
 */
function getProductCount() {
  var countEl = document.querySelector(SELECTORS.productsCount);
  if (countEl) {
    var countValue = countEl.querySelector(SELECTORS.countValue);
    return countValue ? countValue.textContent.trim() : countEl.dataset.visibleCount;
  }
  return null;
}

/**
 * Get the count of active filters
 */
function getActiveFilterCount() {
  var activeFiltersContainer = document.querySelector(SELECTORS.activeFilters);
  if (activeFiltersContainer) {
    // Count the active filter remove links (excluding "Clear all" link)
    var activeFilterLinks = activeFiltersContainer.querySelectorAll('.active__filters__remove:not(.active__filters__clear)');
    return activeFilterLinks.length;
  }
  return 0;
}

/**
 * Announce a message to screen readers via the live region
 */
function announce(message) {
  var liveRegion = document.querySelector(SELECTORS.filterLiveRegion);

  // Create live region if it doesn't exist
  if (!liveRegion) {
    liveRegion = document.createElement('div');
    liveRegion.id = 'filter-live-region';
    liveRegion.className = 'visually-hidden';
    liveRegion.setAttribute('role', 'status');
    liveRegion.setAttribute('aria-live', 'polite');
    liveRegion.setAttribute('aria-atomic', 'true');
    liveRegion.setAttribute('data-filter-live-region', '');
    document.body.appendChild(liveRegion);
  }

  // Clear and set message (needs to be different to trigger announcement)
  liveRegion.textContent = '';

  // Use setTimeout to ensure the DOM updates and triggers the announcement
  setTimeout(function () {
    liveRegion.textContent = message;
  }, 100);
}

/**
 * Handle filter checkbox change
 */
function handleFilterChange(event) {
  var checkbox = event.target;
  var isChecked = checkbox.checked;
  var label = checkbox.nextElementSibling;
  var filterName = label ? label.textContent.trim() : checkbox.value;

  // Announce the immediate action
  var action = isChecked ? 'selected' : 'deselected';
  announce("".concat(filterName, " filter ").concat(action, ". Loading results..."));
}

/**
 * Handle Enter key on checkboxes (checkboxes natively use Space, but users expect Enter to work too)
 */
function handleCheckboxKeydown(event) {
  if (event.key === 'Enter') {
    event.preventDefault();
    var checkbox = event.target;
    checkbox.checked = !checkbox.checked;
    // Trigger change event for any listeners
    checkbox.dispatchEvent(new Event('change', {
      bubbles: true
    }));
    // Trigger input event - this is what the theme's FiltersForm listens for to apply filters via AJAX
    checkbox.dispatchEvent(new Event('input', {
      bubbles: true
    }));
  }
}

/**
 * Initialize filter accessibility
 */
function init() {
  // Target all filter checkboxes on the page (not just in sidebar form)
  var checkboxes = document.querySelectorAll(SELECTORS.filterCheckbox);
  if (checkboxes.length === 0) {
    return;
  }

  // Add change listeners to all filter checkboxes
  checkboxes.forEach(function (checkbox) {
    // Skip if already initialized
    if (checkbox.dataset.filterA11yInit) return;
    checkbox.dataset.filterA11yInit = 'true';
    checkbox.addEventListener('change', handleFilterChange);
    // Allow Enter key to toggle checkbox (in addition to native Space key)
    checkbox.addEventListener('keydown', handleCheckboxKeydown);
  });

  // Announce on page load if filters are active (for page refresh after filter change)
  var productCount = getProductCount();
  var activeFilterCount = getActiveFilterCount();

  // Check if this is a page load after a filter was applied (check URL for filter params)
  var urlParams = new URLSearchParams(window.location.search);
  var hasFilterParams = Array.from(urlParams.keys()).some(function (key) {
    return key.startsWith('filter.') || key === 'sort_by';
  });

  // If we have active filters and this looks like a filtered page, announce results
  if (hasFilterParams && productCount !== null) {
    // Delay announcement to ensure it happens after page is fully loaded
    setTimeout(function () {
      var message = '';
      if (activeFilterCount > 0) {
        message = "".concat(activeFilterCount, " ").concat(activeFilterCount === 1 ? 'filter' : 'filters', " applied. ");
      }
      message += "Showing ".concat(productCount, " ").concat(parseInt(productCount) === 1 ? 'product' : 'products', ".");
      announce(message);
    }, 500);
  }

  // Watch for dynamic updates (if filters use AJAX)
  observeProductUpdates();
}

/**
 * Observe for dynamically updated product counts
 */
function observeProductUpdates() {
  var productsContainer = document.querySelector('[data-products-count]');
  if (!productsContainer) return;
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      if (mutation.type === 'characterData' || mutation.type === 'childList') {
        var newCount = getProductCount();
        if (newCount !== null) {
          var activeFilterCount = getActiveFilterCount();
          var message = '';
          if (activeFilterCount > 0) {
            message = "".concat(activeFilterCount, " ").concat(activeFilterCount === 1 ? 'filter' : 'filters', " applied. ");
          }
          message += "Showing ".concat(newCount, " ").concat(parseInt(newCount) === 1 ? 'product' : 'products', ".");
          announce(message);
        }
      }
    });
  });
  observer.observe(productsContainer, {
    childList: true,
    subtree: true,
    characterData: true
  });
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

// Re-initialize after any dynamic content loads
document.addEventListener('shopify:section:load', init);
/* harmony default export */ var collection_filter_accessibility = ((/* unused pure expression or super */ null && (init)));
;// ./src/js/components/custom-bis-modal.js
function custom_bis_modal_typeof(o) { "@babel/helpers - typeof"; return custom_bis_modal_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, custom_bis_modal_typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function custom_bis_modal_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function custom_bis_modal_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, custom_bis_modal_toPropertyKey(o.key), o); } }
function custom_bis_modal_createClass(e, r, t) { return r && custom_bis_modal_defineProperties(e.prototype, r), t && custom_bis_modal_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function custom_bis_modal_toPropertyKey(t) { var i = custom_bis_modal_toPrimitive(t, "string"); return "symbol" == custom_bis_modal_typeof(i) ? i : i + ""; }
function custom_bis_modal_toPrimitive(t, r) { if ("object" != custom_bis_modal_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != custom_bis_modal_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Custom Back in Stock Modal
 * Handles modal display and form submission to Klaviyo API
 */
var CustomBISModal = /*#__PURE__*/function () {
  function CustomBISModal() {
    var _window$customBisModa, _window$customBisModa2;
    custom_bis_modal_classCallCheck(this, CustomBISModal);
    // Get Klaviyo company ID from Liquid (based on shop.permanent_domain)
    var companyId = ((_window$customBisModa = window.customBisModalData) === null || _window$customBisModa === void 0 ? void 0 : _window$customBisModa.klaviyoCompanyId) || 'SEdrg6';
    this.config = {
      companyId: companyId,
      // Klaviyo public API key
      catalogId: '$custom:::$default',
      // Custom catalog ID
      apiEndpoint: 'https://a.klaviyo.com/client/back-in-stock-subscriptions/',
      profileEndpoint: 'https://a.klaviyo.com/client/profiles/',
      enableTracking: ((_window$customBisModa2 = window.customBisModalData) === null || _window$customBisModa2 === void 0 ? void 0 : _window$customBisModa2.enableTracking) || false
    };
    this.elements = {
      modal: document.getElementById('custom-bis-modal'),
      overlay: null,
      closeButton: null,
      form: null,
      emailInput: null,
      variantSelect: null,
      newsletterCheckbox: null,
      submitButton: null,
      errorMessage: null,
      successMessage: null
    };
    this.currentVariant = null;
    this.productTitle = '';
    this.init();
  }
  return custom_bis_modal_createClass(CustomBISModal, [{
    key: "init",
    value: function init() {
      var _window$customBisModa3, _this$elements$form, _this$elements$form2, _this$elements$form3;
      // Check if custom BIS modal is enabled (defaults to disabled if data not present)
      if (!((_window$customBisModa3 = window.customBisModalData) !== null && _window$customBisModa3 !== void 0 && _window$customBisModa3.enabled)) {
        return;
      }
      if (!this.elements.modal) {
        console.error('Custom BIS Modal: Modal element not found');
        return;
      }

      // Cache DOM elements
      this.elements.overlay = this.elements.modal.querySelector('.custom-bis-modal__overlay');
      this.elements.closeButton = this.elements.modal.querySelector('.custom-bis-modal__close');
      this.elements.form = document.getElementById('custom-bis-form');
      this.elements.emailInput = document.getElementById('custom-bis-email');
      this.elements.variantSelect = document.getElementById('custom-bis-variant');
      this.elements.newsletterCheckbox = document.getElementById('custom-bis-newsletter');
      this.elements.submitButton = (_this$elements$form = this.elements.form) === null || _this$elements$form === void 0 ? void 0 : _this$elements$form.querySelector('.custom-bis-form__submit');
      this.elements.errorMessage = (_this$elements$form2 = this.elements.form) === null || _this$elements$form2 === void 0 ? void 0 : _this$elements$form2.querySelector('.custom-bis-form__message--error');
      this.elements.successMessage = (_this$elements$form3 = this.elements.form) === null || _this$elements$form3 === void 0 ? void 0 : _this$elements$form3.querySelector('.custom-bis-form__message--success');

      // Get product data from window
      if (window.customBisModalData) {
        this.productTitle = window.customBisModalData.productTitle;
      }
      this.bindEvents();
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      var _this = this;
      // Notify button clicks
      document.addEventListener('click', function (e) {
        if (e.target.closest('.pv__notify')) {
          e.preventDefault();
          _this.openModal();
        }
      });

      // Close button
      if (this.elements.closeButton) {
        this.elements.closeButton.addEventListener('click', function () {
          return _this.closeModal();
        });
      }

      // Overlay click
      if (this.elements.overlay) {
        this.elements.overlay.addEventListener('click', function () {
          return _this.closeModal();
        });
      }

      // Form submission
      if (this.elements.form) {
        this.elements.form.addEventListener('submit', function (e) {
          e.preventDefault();
          _this.handleSubmit();
        });
      }

      // Escape key
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && _this.isModalOpen()) {
          _this.closeModal();
        }
      });
    }
  }, {
    key: "openModal",
    value: function openModal() {
      var _this2 = this;
      // Reset form first (clears previous state)
      this.resetForm();

      // Populate variant dropdown (includes auto-selection)
      this.populateVariantDropdown();

      // Show modal
      if (this.elements.modal) {
        this.elements.modal.style.display = 'block';
        document.body.style.overflow = 'hidden';

        // Focus email input
        setTimeout(function () {
          if (_this2.elements.emailInput) {
            _this2.elements.emailInput.focus();
          }
        }, 100);
      }
    }
  }, {
    key: "populateVariantDropdown",
    value: function populateVariantDropdown() {
      var _this3 = this;
      if (!this.elements.variantSelect) return;

      // Clear existing options except the first one
      this.elements.variantSelect.innerHTML = '<option value="">Select a size</option>';

      // Get product variants
      if (!window.productJson || !window.productJson.variants) {
        console.error('Custom BIS Modal: Product variants not found');
        return;
      }
      var variants = window.productJson.variants;

      // Get currently selected variant from the size button with 'current' class
      var selectedSizeButton = document.querySelector('.product__circle.current[data-variant-id]');
      var selectedVariantId = selectedSizeButton ? parseInt(selectedSizeButton.dataset.variantId, 10) : null;

      // Only add out-of-stock variants
      variants.forEach(function (variant) {
        if (variant.available) return; // Skip available variants

        var option = document.createElement('option');
        option.value = variant.id;

        // Build variant title (e.g., "Color / Size" or just "Size")
        var variantTitle = '';
        if (variant.option1 && variant.option1 !== 'Default Title') {
          variantTitle = variant.option1;
        }
        if (variant.option2 && variant.option2 !== 'Default Title') {
          variantTitle += (variantTitle ? ' / ' : '') + variant.option2;
        }
        if (variant.option3 && variant.option3 !== 'Default Title') {
          variantTitle += (variantTitle ? ' / ' : '') + variant.option3;
        }

        // If no options, use variant title
        if (!variantTitle) {
          variantTitle = variant.title;
        }
        option.textContent = variantTitle;

        // Auto-select if this matches the currently selected size button
        if (selectedVariantId && variant.id === selectedVariantId) {
          option.selected = true;
        }
        _this3.elements.variantSelect.appendChild(option);
      });
    }
  }, {
    key: "closeModal",
    value: function closeModal() {
      if (this.elements.modal) {
        this.elements.modal.style.display = 'none';
        document.body.style.overflow = '';
      }
    }
  }, {
    key: "isModalOpen",
    value: function isModalOpen() {
      return this.elements.modal && this.elements.modal.style.display === 'block';
    }
  }, {
    key: "resetForm",
    value: function resetForm() {
      if (this.elements.form) {
        this.elements.form.reset();
      }

      // Re-check newsletter checkbox
      if (this.elements.newsletterCheckbox) {
        this.elements.newsletterCheckbox.checked = true;
      }
      this.hideMessages();
    }
  }, {
    key: "hideMessages",
    value: function hideMessages() {
      if (this.elements.errorMessage) {
        this.elements.errorMessage.style.display = 'none';
        this.elements.errorMessage.textContent = '';
      }
      if (this.elements.successMessage) {
        this.elements.successMessage.style.display = 'none';
      }
    }
  }, {
    key: "showError",
    value: function showError(message) {
      if (this.elements.errorMessage) {
        this.elements.errorMessage.textContent = message;
        this.elements.errorMessage.style.display = 'block';
      }
    }
  }, {
    key: "showSuccess",
    value: function showSuccess() {
      var _this$elements$form4,
        _this4 = this;
      if (this.elements.successMessage) {
        this.elements.successMessage.style.display = 'block';
      }

      // Hide form fields
      var formFields = (_this$elements$form4 = this.elements.form) === null || _this$elements$form4 === void 0 ? void 0 : _this$elements$form4.querySelectorAll('.custom-bis-form__field, .custom-bis-form__checkbox, .custom-bis-form__submit');
      formFields === null || formFields === void 0 || formFields.forEach(function (field) {
        field.style.display = 'none';
      });

      // Auto close after 3 seconds
      setTimeout(function () {
        _this4.closeModal();
        // Show form fields again for next time
        formFields === null || formFields === void 0 || formFields.forEach(function (field) {
          field.style.display = '';
        });
        _this4.resetForm();
      }, 3000);
    }
  }, {
    key: "handleSubmit",
    value: function () {
      var _handleSubmit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _this$elements$emailI, _this$elements$varian;
        var email, selectedVariantId, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.hideMessages();

              // Validate email
              email = (_this$elements$emailI = this.elements.emailInput) === null || _this$elements$emailI === void 0 || (_this$elements$emailI = _this$elements$emailI.value) === null || _this$elements$emailI === void 0 ? void 0 : _this$elements$emailI.trim();
              if (email) {
                _context.n = 1;
                break;
              }
              this.showError('Please enter your email address.');
              return _context.a(2);
            case 1:
              // Get selected variant from dropdown
              selectedVariantId = (_this$elements$varian = this.elements.variantSelect) === null || _this$elements$varian === void 0 ? void 0 : _this$elements$varian.value;
              if (selectedVariantId) {
                _context.n = 2;
                break;
              }
              this.showError('Please select a variant.');
              return _context.a(2);
            case 2:
              // Find the variant object from the selected ID
              if (window.productJson && window.productJson.variants) {
                this.currentVariant = window.productJson.variants.find(function (v) {
                  return v.id == selectedVariantId;
                });
              }
              if (!(!this.currentVariant || !this.currentVariant.id)) {
                _context.n = 3;
                break;
              }
              this.showError('Unable to get product variant. Please try again.');
              return _context.a(2);
            case 3:
              // Disable submit button
              if (this.elements.submitButton) {
                this.elements.submitButton.disabled = true;
                this.elements.submitButton.textContent = 'Submitting...';
              }
              _context.p = 4;
              _context.n = 5;
              return this.submitToKlaviyo(email);
            case 5:
              if (!this.config.enableTracking) {
                _context.n = 6;
                break;
              }
              _context.n = 6;
              return this.updateProfileTracking(email).catch(function (err) {
                // Fail silently - BIS subscription succeeded, tracking is non-critical
                console.warn('Custom BIS Modal: Profile tracking failed', err);
              });
            case 6:
              this.showSuccess();
              _context.n = 8;
              break;
            case 7:
              _context.p = 7;
              _t = _context.v;
              console.error('Custom BIS Modal: Submission error', _t);
              this.showError(_t.message || 'Something went wrong. Please try again.');
            case 8:
              _context.p = 8;
              // Re-enable submit button
              if (this.elements.submitButton) {
                this.elements.submitButton.disabled = false;
                this.elements.submitButton.textContent = 'Notify me when available';
              }
              return _context.f(8);
            case 9:
              return _context.a(2);
          }
        }, _callee, this, [[4, 7, 8, 9]]);
      }));
      function handleSubmit() {
        return _handleSubmit.apply(this, arguments);
      }
      return handleSubmit;
    }()
  }, {
    key: "submitToKlaviyo",
    value: function () {
      var _submitToKlaviyo = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(email) {
        var variantCompositeId, payload, url, response, errorMessage, errorData, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              // Construct variant ID in the format: $custom:::$default:::variantId
              variantCompositeId = "".concat(this.config.catalogId, ":::").concat(this.currentVariant.id); // Construct the payload
              payload = {
                data: {
                  type: 'back-in-stock-subscription',
                  attributes: {
                    profile: {
                      data: {
                        type: 'profile',
                        attributes: {
                          email: email
                        }
                      }
                    },
                    channels: ['EMAIL']
                  },
                  relationships: {
                    variant: {
                      data: {
                        type: 'catalog-variant',
                        id: variantCompositeId
                      }
                    }
                  }
                }
              }; // Make API request
              url = "".concat(this.config.apiEndpoint, "?company_id=").concat(this.config.companyId);
              _context2.n = 1;
              return fetch(url, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json',
                  'revision': '2026-01-15'
                },
                body: JSON.stringify(payload)
              });
            case 1:
              response = _context2.v;
              if (!(response.status === 202)) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2);
            case 2:
              if (response.ok) {
                _context2.n = 7;
                break;
              }
              errorMessage = 'Failed to subscribe. Please try again.';
              _context2.p = 3;
              _context2.n = 4;
              return response.json();
            case 4:
              errorData = _context2.v;
              if (errorData.errors && errorData.errors.length > 0) {
                errorMessage = errorData.errors[0].detail || errorMessage;
              }
              _context2.n = 6;
              break;
            case 5:
              _context2.p = 5;
              _t2 = _context2.v;
            case 6:
              throw new Error(errorMessage);
            case 7:
              return _context2.a(2);
          }
        }, _callee2, this, [[3, 5]]);
      }));
      function submitToKlaviyo(_x) {
        return _submitToKlaviyo.apply(this, arguments);
      }
      return submitToKlaviyo;
    }()
  }, {
    key: "updateProfileTracking",
    value: function () {
      var _updateProfileTracking = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(email) {
        var _window$customBisModa4;
        var payload, url, response;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              payload = {
                data: {
                  type: 'profile',
                  attributes: {
                    email: email,
                    properties: {
                      'Last BIS Source': 'Custom Modal',
                      'Last BIS Catalog': this.config.catalogId,
                      'Last BIS Product': this.productTitle,
                      'Last BIS Product ID': ((_window$customBisModa4 = window.customBisModalData) === null || _window$customBisModa4 === void 0 ? void 0 : _window$customBisModa4.productId) || null,
                      'Last BIS Variant': this.currentVariant.title,
                      'Last BIS Variant ID': this.currentVariant.id,
                      'Last BIS Date': new Date().toISOString()
                    }
                  }
                }
              };
              url = "".concat(this.config.profileEndpoint, "?company_id=").concat(this.config.companyId);
              _context3.n = 1;
              return fetch(url, {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json',
                  'revision': '2026-01-15'
                },
                body: JSON.stringify(payload)
              });
            case 1:
              response = _context3.v;
              if (!(!response.ok && response.status !== 201)) {
                _context3.n = 2;
                break;
              }
              throw new Error('Failed to update profile tracking');
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function updateProfileTracking(_x2) {
        return _updateProfileTracking.apply(this, arguments);
      }
      return updateProfileTracking;
    }()
  }]);
}(); // Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    new CustomBISModal();
  });
} else {
  new CustomBISModal();
}
/* harmony default export */ var custom_bis_modal = (CustomBISModal);
;// ./src/js/components/collection-pill-nav.js
/**
 * Collection pill navigation (Style B) — desktop click-and-drag to scroll.
 *
 * The pill list is a CSS scroll carousel (overflow-x). Mobile scrolls by touch
 * swipe (native). On desktop, users grab the track with the mouse and drag it
 * horizontally. Capture + preventDefault are deferred until the pointer actually
 * moves past a threshold, so a plain click still navigates to the collection.
 */

var collection_pill_nav_SELECTORS = {
  root: '[data-collection-pill-nav]',
  track: '[data-pill-nav-track]',
  pill: '.collection-pill-nav__btn'
};

// Distance (px) the pointer must travel before we treat the gesture as a drag
// rather than a click on a pill.
var DRAG_THRESHOLD = 5;

/**
 * Normalise a query string to an order-independent, de-duplicated key so two
 * URLs with the same filters in a different order (or a repeated param, which
 * these pill hrefs do contain) still compare equal.
 */
function paramsKey(search) {
  var params = new URLSearchParams(search);
  var parts = new Set();
  params.forEach(function (value, key) {
    return parts.add("".concat(key, "=").concat(value));
  });
  return Array.from(parts).sort().join('&');
}

/**
 * Flag the pill matching the current URL.
 *
 * This cannot be done in Liquid: the pill hrefs carry filter query strings, but
 * Liquid only exposes request.path (no query), so the template's nav_active test
 * can never match a filtered pill and aria-current was never being emitted.
 */
function markActivePill(root) {
  var pills = root.querySelectorAll(collection_pill_nav_SELECTORS.pill);
  if (!pills.length) return;
  var currentParams = paramsKey(window.location.search);
  pills.forEach(function (pill) {
    var target;
    try {
      target = new URL(pill.getAttribute('href'), window.location.origin);
    } catch (e) {
      return;
    }
    var isActive = target.pathname === window.location.pathname && paramsKey(target.search) === currentParams;
    if (isActive) {
      pill.setAttribute('aria-current', 'page');
      pill.classList.add('is-active');
    } else {
      pill.removeAttribute('aria-current');
      pill.classList.remove('is-active');
    }
  });
}
function setup(root) {
  if (root.dataset.pillNavReady === 'true') return;
  var track = root.querySelector(collection_pill_nav_SELECTORS.track);
  if (!track) return;
  root.dataset.pillNavReady = 'true';
  markActivePill(root);
  var isDown = false;
  var dragged = false;
  var startX = 0;
  var startScroll = 0;
  var pointerX = 0;
  var rafId = null;

  // Apply the scroll once per animation frame so multiple pointermove events in
  // the same frame collapse into a single layout write (removes the jitter).
  var applyScroll = function applyScroll() {
    rafId = null;
    track.scrollLeft = startScroll - (pointerX - startX);
  };
  var onPointerDown = function onPointerDown(e) {
    // Mouse only — touch devices scroll natively via swipe.
    if (e.pointerType && e.pointerType !== 'mouse') return;
    // NOTE: do NOT preventDefault or capture the pointer here — that would break a
    // plain click's navigation. We only commit to a drag once the pointer actually
    // moves past the threshold (see onPointerMove).
    isDown = true;
    dragged = false;
    startX = e.clientX;
    startScroll = track.scrollLeft;
    pointerX = e.clientX;
  };
  var onPointerMove = function onPointerMove(e) {
    if (!isDown) return;
    pointerX = e.clientX;

    // First move past the threshold promotes this gesture to a drag. Only then do
    // we capture the pointer and suppress default (text/link drag) — leaving plain
    // clicks untouched so pill links still navigate.
    if (!dragged && Math.abs(pointerX - startX) > DRAG_THRESHOLD) {
      dragged = true;
      if (track.setPointerCapture) track.setPointerCapture(e.pointerId);
      track.classList.add('is-dragging');
    }
    if (!dragged) return;
    e.preventDefault();
    if (rafId === null) rafId = requestAnimationFrame(applyScroll);
  };
  var endDrag = function endDrag(e) {
    if (!isDown) return;
    isDown = false;
    if (rafId !== null) {
      cancelAnimationFrame(rafId);
      rafId = null;
    }
    if (e && e.pointerId != null && track.hasPointerCapture && track.hasPointerCapture(e.pointerId)) {
      track.releasePointerCapture(e.pointerId);
    }
    track.classList.remove('is-dragging');
  };
  track.addEventListener('pointerdown', onPointerDown);
  track.addEventListener('pointermove', onPointerMove);
  track.addEventListener('pointerup', endDrag);
  track.addEventListener('pointercancel', endDrag);

  // Kill the native drag on the pill anchors (Firefox fires dragstart on links).
  track.addEventListener('dragstart', function (e) {
    return e.preventDefault();
  });

  // If the gesture was a drag, swallow the follow-up click so it doesn't
  // activate the pill link the pointer happened to be over.
  track.addEventListener('click', function (e) {
    if (dragged) {
      e.preventDefault();
      e.stopPropagation();
      dragged = false;
    }
  }, true);
}
function collection_pill_nav_init() {
  document.querySelectorAll(collection_pill_nav_SELECTORS.root).forEach(setup);
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', collection_pill_nav_init);
} else {
  collection_pill_nav_init();
}

// Re-initialize after the section is re-rendered in the theme editor.
document.addEventListener('shopify:section:load', collection_pill_nav_init);
/* harmony default export */ var collection_pill_nav = ((/* unused pure expression or super */ null && (collection_pill_nav_init)));
;// ./src/js/components/sfs-policy.js
function sfs_policy_typeof(o) { "@babel/helpers - typeof"; return sfs_policy_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, sfs_policy_typeof(o); }
/**
 * SFS storefront policy — the two public metafields are the full contract:
 *   fe_sfs.web_purchasable           false (or "false") blocks online purchase.
 *   fe_sfs.max_purchasable_quantity  positive integer caps online quantity.
 * Both fail open: anything missing/null/unreadable → current theme behavior.
 * Pure, DOM-free, unit-tested. Every add/quantity surface routes through this.
 */

var GIFT_CARD = 'Gift Card';

// Normalize a serialized entry into { webPurchasable, maxPurchasableQuantity }.
// Accepts the policy object, a legacy bare boolean/null, or undefined.
function parseSfsPolicy(raw) {
  var webRaw;
  var maxRaw;
  if (raw && sfs_policy_typeof(raw) === 'object') {
    webRaw = raw.web_purchasable;
    maxRaw = raw.max_purchasable_quantity;
  } else {
    webRaw = raw; // legacy bare boolean / null
    maxRaw = null;
  }
  var webPurchasable = !(webRaw === false || webRaw === 'false');
  var parsedMax = Number(maxRaw);
  var maxPurchasableQuantity = maxRaw !== null && maxRaw !== '' && Number.isInteger(parsedMax) && parsedMax > 0 ? parsedMax : null;
  return {
    webPurchasable: webPurchasable,
    maxPurchasableQuantity: maxPurchasableQuantity
  };
}

// Total quantity of `variantId` already in the cart (CartJS.cart.items shape).
function cartQuantityForVariant(cartItems, variantId) {
  if (!Array.isArray(cartItems) || variantId == null) {
    return 0;
  }
  var wanted = String(variantId);
  return cartItems.filter(function (item) {
    return String(item.id) === wanted || String(item.variant_id) === wanted;
  }).reduce(function (sum, item) {
    return sum + (Number(item.quantity) || 0);
  }, 0);
}

// The guard. `policy` is the output of parseSfsPolicy. options.name → gift-card exemption.
function validateSfsDesiredQuantity(policy, desiredQuantity) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var name = options.name || '';
  if (name.includes(GIFT_CARD)) {
    return {
      allowed: true
    };
  }
  if (policy.webPurchasable === false) {
    return {
      allowed: false
    };
  }
  if (policy.maxPurchasableQuantity && desiredQuantity > policy.maxPurchasableQuantity) {
    return {
      allowed: false
    };
  }
  return {
    allowed: true
  };
}
;// ./src/js/components/sfs-add-to-cart-guard.js
/**
 * SFS guard (quickview drawer).
 *
 * Source of truth is the metafield `fe_sfs.web_purchasable`, emitted per
 * variant by api-product-quickview.liquid as a JSON map
 *   <script data-fe-sfs-web-purchasable data-form="<formId>">{ "<variantId>": false|true|null }</script>
 * A variant is blocked when its value is exactly `false`. SFS-blocked variants
 * are still `available`, so the vendor <product-form> (theme.dev.js, not
 * editable here) treats them as in-stock — it leaves the Add button enabled and
 * STRIPS the server-rendered `sold-out` class off the size radio. This module
 * re-asserts the blocked state from the metafield:
 *
 *   1. Mark blocked options — re-add `sold-out` to any option radio whose
 *      resulting variant is blocked (the visual the vendor removed).
 *   2. Disable the Add to Bag button when the selected variant is blocked.
 *   3. Submit guard — cancel the submit before the vendor handler fires.
 *
 * A MutationObserver (disconnect/reconnect to avoid self-trigger loops) keeps
 * all three applied across the vendor's re-renders. We only manage state we own
 * (own `data-sfs-soldout` flag; only ever ADD the button `disabled`), so we
 * never fight the vendor's genuine out-of-stock handling.
 */


var ADD_BUTTON = '[name="add"]';
var OWN_SOLD_OUT = 'data-sfs-soldout';
var observedForms = new WeakSet();
var productCache = new WeakMap();
function getProductJson(form) {
  if (productCache.has(form)) return productCache.get(form);
  var el = form.querySelector('[data-product-json]');
  var data = null;
  try {
    data = el ? JSON.parse(el.textContent) : null;
  } catch (error) {
    data = null;
  }
  productCache.set(form, data);
  return data;
}

// variantId -> false|true|null, from the metafield-backed map for this form.
function getWebPurchasableMap(formId) {
  var el = document.querySelector("[data-fe-sfs-web-purchasable][data-form=\"".concat(formId, "\"]"));
  if (!el) return {};
  try {
    return JSON.parse(el.textContent || '{}') || {};
  } catch (error) {
    return {};
  }
}
function getOptionNames(product) {
  return (product.options || []).map(function (opt) {
    return typeof opt === 'string' ? opt : opt && opt.name;
  });
}

// Currently-checked value for each option group, e.g. { Color: 'Olive', Size: '00' }.
function getSelectedOptions(form) {
  var formId = form.getAttribute('id');
  var selected = {};
  document.querySelectorAll("input[type=\"radio\"][form=\"".concat(formId, "\"][name^=\"options[\"]:checked")).forEach(function (input) {
    var match = input.name.match(/^options\[(.+)\]$/);
    if (match) selected[match[1]] = input.value;
  });
  return selected;
}
function findVariant(product, wantedValues) {
  if (wantedValues.some(function (v) {
    return v == null;
  })) return null;
  return product.variants.find(function (v) {
    return Array.isArray(v.options) && v.options.length === wantedValues.length && v.options.every(function (val, i) {
      return val === wantedValues[i];
    });
  });
}
function isBlockedVariantId(map, variantId) {
  return variantId != null && parseSfsPolicy(map[String(variantId)]).webPurchasable === false;
}

// 1. Re-add `sold-out` to every option radio whose resulting variant is blocked
//    (for radio R in group G: combine R's value with the current selection of
//    the other groups). Only manage classes we added (OWN_SOLD_OUT flag).
function markBlockedOptions(form) {
  var product = getProductJson(form);
  if (!product || !Array.isArray(product.variants)) return;
  var formId = form.getAttribute('id');
  var map = getWebPurchasableMap(formId);
  var optionNames = getOptionNames(product);
  var selected = getSelectedOptions(form);
  document.querySelectorAll("input[type=\"radio\"][form=\"".concat(formId, "\"][name^=\"options[\"]")).forEach(function (radio) {
    var match = radio.name.match(/^options\[(.+)\]$/);
    if (!match) return;
    var groupName = match[1];
    var wanted = optionNames.map(function (name) {
      return name === groupName ? radio.value : selected[name];
    });
    var variant = findVariant(product, wanted);
    var blocked = variant && isBlockedVariantId(map, variant.id);
    if (blocked) {
      radio.classList.add('sold-out');
      radio.setAttribute(OWN_SOLD_OUT, 'true');
    } else if (radio.getAttribute(OWN_SOLD_OUT) === 'true') {
      radio.classList.remove('sold-out');
      radio.removeAttribute(OWN_SOLD_OUT);
    }
  });
}

// 2. Disable the Add to Bag button when the selected variant is blocked.
function syncAddButton(form) {
  var addButton = form.querySelector(ADD_BUTTON);
  if (!addButton) return;
  var formId = form.getAttribute('id');
  var map = getWebPurchasableMap(formId);
  var product = getProductJson(form);
  if (!product) return;
  var wanted = getOptionNames(product).map(function (name) {
    return getSelectedOptions(form)[name];
  });
  var variant = findVariant(product, wanted);

  // Only ever ADD disabled — re-enabling for an unblocked variant is left to
  // the vendor, so we never re-enable a genuinely sold-out variant.
  if (variant && isBlockedVariantId(map, variant.id) && !addButton.disabled) {
    addButton.disabled = true;
  }
}
function applyState(form) {
  if (!form || !form.hasAttribute('data-product-form')) return;
  markBlockedOptions(form);
  syncAddButton(form);
}

// Keep state applied across the vendor's re-renders / class-stripping.
// Disconnect while we mutate so our own changes don't retrigger the observer.
function watchForm(form) {
  if (observedForms.has(form)) return;
  observedForms.add(form);
  var config = {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'disabled']
  };
  var observer = new MutationObserver(function () {
    observer.disconnect();
    applyState(form);
    observer.observe(form, config);
  });
  observer.observe(form, config);
}
function sfsAddToCartGuard() {
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;
    var form = input.form; // resolves the form="" association
    if (!form || !form.hasAttribute('data-product-form')) return;
    watchForm(form);
    // Defer so the vendor handler runs first; we then re-assert on top.
    setTimeout(function () {
      return applyState(form);
    }, 0);
  });
  var hookForm = function hookForm(form) {
    watchForm(form);
    applyState(form);
  };

  // Hook any quickview form already in the DOM at init.
  document.querySelectorAll('form[data-product-form]').forEach(hookForm);

  // The quickview drawer is injected after page load, so watch the document for
  // product forms added later and hook them when they appear.
  var bodyObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!(node instanceof HTMLElement)) return;
        if (node.matches('form[data-product-form]')) {
          hookForm(node);
        }
        node.querySelectorAll('form[data-product-form]').forEach(hookForm);
      });
    });
  });
  bodyObserver.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Submit guard: cancel before the vendor handler fires.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.hasAttribute('data-product-form')) return;
    var product = getProductJson(form);
    if (!product) return;
    var map = getWebPurchasableMap(form.getAttribute('id'));
    var wanted = getOptionNames(product).map(function (name) {
      return getSelectedOptions(form)[name];
    });
    var variant = findVariant(product, wanted);
    if (!variant) return;
    var policy = parseSfsPolicy(map[String(variant.id)]);
    var cartItems = window.CartJS && CartJS.cart && CartJS.cart.items || [];
    var desiredQuantity = cartQuantityForVariant(cartItems, variant.id) + 1;
    var result = validateSfsDesiredQuantity(policy, desiredQuantity, {
      name: variant.name
    });
    if (!result.allowed) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
}
;// ./src/js/components/sfs-cart-quantity-guard.js
/**
 * SFS cart quantity guard (cart drawer + cart page).
 *
 * The vendor bundle (theme.dev.js, not editable) owns the +/- buttons and the
 * `change`-driven post to /cart/change.js. We intercept the quantity input's
 * `change` in the capture phase BEFORE the vendor's bubble-phase handler. When
 * the requested quantity exceeds the variant's online cap we cancel the event
 * (so the vendor never posts) and reset the input to the cap. Silent by design —
 * no message is surfaced. Delegated on document, so it survives cart drawer
 * re-renders.
 *
 * Policy is serialized per line onto the input's data-* attributes by
 * snippets/cart-line-items.liquid.
 */


function policyFromInput(input) {
  return parseSfsPolicy({
    web_purchasable: input.getAttribute('data-sfs-web-purchasable'),
    max_purchasable_quantity: input.getAttribute('data-sfs-max-purchasable-quantity')
  });
}
function sfsCartQuantityGuard() {
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.hasAttribute('data-quantity-input') || !input.hasAttribute('data-sfs-max-purchasable-quantity')) {
      return;
    }
    var desiredQuantity = Number(input.value);
    if (!Number.isFinite(desiredQuantity)) return;
    var variantName = input.getAttribute('data-sfs-variant-name') || '';
    var policy = policyFromInput(input);
    var result = validateSfsDesiredQuantity(policy, desiredQuantity, {
      name: variantName
    });
    if (result.allowed) return;

    // Cancel the vendor update. Reset the displayed quantity so it can't
    // disagree with the unchanged cart line: clamp to the cap when there is
    // one, otherwise (e.g. web_purchasable=false) fall back to the
    // server-rendered line quantity (the input's default value).
    event.preventDefault();
    event.stopImmediatePropagation();
    var cap = policy.maxPurchasableQuantity;
    input.value = cap ? String(cap) : input.defaultValue || input.value;
  }, true // capture: run before the vendor's bubble-phase handler
  );
}
;// ./src/js/components/swatch-hover.js
/**
 * Hover-hydrated collection swatches.
 *
 * The grid ships an empty `.grid__swatch__hover` carrying `data-swatch-url`. The
 * sibling swatch row is fetched and injected the first time the shopper hovers,
 * touches, or tabs to the card.
 *
 * WHY
 * Rendering this markup for all 50 cards cost ~64% of every filter interaction
 * (5,822ms with swatches vs 2,112ms without — Mann-Whitney U=20/20, p=0.008) while
 * CSS hid every one of them at `opacity: 0` until hover. The design already gated
 * swatches behind hover; this aligns the work with the interaction rather than
 * deferring something the shopper could see.
 *
 * See docs/2026-07-30_collection-filters-performance-algolia-assessment.md §10.6.4.
 */

var swatch_hover_SELECTORS = {
  target: '[data-swatch-url]',
  card: '.product-grid-item',
  scrollbar: '[data-scrollbar-slider]',
  contentSlot: '[data-sibling-content-slot]',
  priceSlot: '[data-sibling-price-slot]',
  quickaddSlot: '[data-quickadd-slot]',
  // Scoped to the target's own container, NOT the card: injected sibling contents bring
  // their own swatch containers, so a card-level query could resolve to one of those.
  swatchContainer: '.grid__swatch__container',
  countPlaceholder: '.grid__swatch__placeholder'
};

// The fragment returns three blocks. Each goes to a different place in the card,
// so they cannot share one container:
//   swatches — into .grid__swatch__hover (absolutely positioned, hidden until hover)
//   contents — must be DIRECT children of <product-grid-item>, because
//              ProductGridItem.siblingClickEvent toggles `hidden` on them and the
//              visible card content sits in the same flow
//   prices   — likewise, next to the primary price wrapper
var FRAGMENTS = {
  swatches: '[data-fragment="swatches"]',
  contents: '[data-fragment="contents"]',
  prices: '[data-fragment="prices"]',
  quickadd: '[data-fragment="quickadd"]',
  // Present in the fragment but deliberately unused — the card's label is fixed at
  // "More colors" and is never rewritten. See the note further down.
  swatchCount: '[data-fragment="swatch-count"]'
};

// Keyed on the fragment url, which is unique per product. Deliberately NOT keyed on
// `data-swatch-handle` — that attribute belongs to the theme's ColorMatch system
// (theme.dev.js:1659) and is not ours to reuse.
var cache = new Map();
var inflight = new Map();
function fetchFragment(url) {
  if (cache.has(url)) return Promise.resolve(cache.get(url));
  if (inflight.has(url)) return inflight.get(url);
  var request = fetch(url).then(function (response) {
    if (!response.ok) throw new Error("swatch fragment ".concat(response.status));
    return response.text();
  }).then(function (html) {
    // A section-rendered fragment is bare markup. If we get a whole document
    // back, the section_id did not take effect — injecting it would drop the
    // entire page (header, scripts and all) inside a product card. Refuse it.
    if (/<(!doctype|html|head)\b/i.test(html.slice(0, 2000))) {
      throw new Error('swatch fragment returned a full page, not a section');
    }
    cache.set(url, html);
    inflight.delete(url);
    return html;
  }).catch(function (error) {
    inflight.delete(url);
    throw error;
  });
  inflight.set(url, request);
  return request;
}

/**
 * Announce that a swatch row has been injected. The vendor bundle listens and does
 * two things that cannot happen from here, because both classes are module-scoped
 * inside theme.dev.js:
 *
 *   1. NativeScrollbar — the injected markup has a scrollbar and prev/next arrows,
 *      which are NOT custom elements and do not self-upgrade on innerHTML insertion.
 *      (§3.4 of the assessment covers <radio-swatch> etc., not these.)
 *   2. ProductGridItem.bindVariantLinks() — swatch click swaps the visible product
 *      image and price. ProductGridItem binds those links when it connects, which is
 *      long before these exist, so without a re-bind clicking a swatch does nothing.
 *
 * Dispatched unconditionally: (2) is required even if (1) finds no scrollbar.
 */
function announceLoaded(container) {
  container.dispatchEvent(new CustomEvent('theme:swatches:loaded', {
    bubbles: true,
    detail: {
      container: container
    }
  }));
}

// Placeholder dots shown while the fragment is in flight. Reuses the real layout
// classes (.sibs__inner / .siblings__link__holder) so spacing matches the loaded
// state exactly and only the dot itself needs styling.
//
// Four is arbitrary but safe: .grid__swatch__hover is position:absolute, so a
// mismatch against the true swatch count cannot shift the card.
var SKELETON_DOTS = 4;
function skeletonMarkup() {
  var dots = new Array(SKELETON_DOTS).fill('<div class="siblings__link__holder"><span class="swatch-skeleton__dot"></span></div>').join('');
  return "<div class=\"sibs__slider\"><div class=\"sibs__inner swatch-skeleton\" aria-hidden=\"true\">".concat(dots, "</div></div>");
}

/**
 * Move a fragment block's children in front of a marker, so they become direct
 * siblings of the card's own content rather than nesting inside a wrapper.
 *
 * Nesting would break two things: CSS that targets these as children of
 * <product-grid-item>, and the visual swap on swatch click, which relies on the
 * revealed sibling occupying the same slot as the hidden primary.
 */
function injectBefore(marker, block) {
  if (!marker || !block) return;
  while (block.firstChild) {
    marker.parentNode.insertBefore(block.firstChild, marker);
  }
}

/**
 * Append a block's children INSIDE a container, rather than beside it.
 *
 * The distinction matters. The content and price markers are empty <span> placeholders
 * standing in for elements that must become siblings, so those use injectBefore(). The
 * quick-add slot is the <ul class="inline-add-product__options-menu-list"> itself, which
 * carries `display: flex; flex-flow: row wrap` — inserting the <li>s beside it dropped
 * them into the menu div instead and they stacked into a column.
 */
function injectInto(container, block) {
  if (!container || !block) return;
  while (block.firstChild) {
    container.appendChild(block.firstChild);
  }
}

/**
 * True when the container's swatch links were rendered server-side.
 *
 * The two swatch paths differ here. The siblings path ships an EMPTY container and the
 * fragment supplies its row. The option path (`elsif has_swatches`) builds its own links
 * inline — they are cheap, needing no collection load — and only defers the hidden card
 * contents. Wiping that container, or covering it with a skeleton, would destroy working
 * server-rendered markup.
 */
function hasServerRenderedSwatches(target) {
  return target.children.length > 0;
}

/**
 * Replace the card's "N Colors" label with the fragment's precise count.
 *
 * The grid renders that label from `sibs_collection.products_count`, which counts every
 * product in the siblings collection — including unavailable and fabric-mismatched ones —
 * because the precise scan was too expensive to run 50 times per filter interaction
 * (commit 9acd71fe). The fragment runs that scan for this one product and ships the
 * finished, translated string.
 *
 * Writes only on a genuine difference. The fragment falls back to the same cheap count
 * whenever the product has no fabric tag or no matching swatch collection, so on most
 * cards the two strings are identical and this touches nothing — no repaint, and no digit
 * visibly changing under the cursor at the exact moment the swatches fade in.
 */
// The label is NOT rewritten after the fetch.
//
// It used to be swapped to the exact "N colors available" once the fragment arrived. The
// card now says "More colors" from first paint, so there is no number to correct — and
// changing the words under a shopper who is mid-hover was the reason the count was
// inaccurate-then-accurate rather than simply stable.
//
// FRAGMENTS.swatchCount is still requested by the section (api-product-swatches.liquid:295)
// and simply ignored here; removing it from the fragment is a server-side change and not
// worth a second round trip to save a span.

function applyFragment(target, html) {
  var holder = document.createElement('div');
  holder.innerHTML = html;

  // Mode A (`data-swatches-inline`) has already rendered this row server-side; overwriting
  // it with the fetched copy would replace identical markup and throw away the point of not
  // deferring. The other fragments below still apply — A defers sibling contents, prices and
  // quick-add exactly as B does, it only renders the SWATCHES eagerly.
  var swatches = holder.querySelector(FRAGMENTS.swatches);
  if (swatches && !target.hasAttribute('data-swatches-inline')) {
    target.innerHTML = swatches.innerHTML;
  }
  // No swatches block (option path) — leave the server-rendered links untouched.

  // Contents and prices are injected once per card. Re-hydration (cache hit after a
  // grid re-render) is fine because the whole card is new markup at that point.
  var card = target.closest(swatch_hover_SELECTORS.card);
  if (card) {
    injectBefore(card.querySelector(swatch_hover_SELECTORS.contentSlot), holder.querySelector(FRAGMENTS.contents));
    injectBefore(card.querySelector(swatch_hover_SELECTORS.priceSlot), holder.querySelector(FRAGMENTS.prices));

    // Quick-add size buttons for the visible card. Only the FIRST empty slot is filled —
    // injected sibling contents bring their own buttons already rendered, and would
    // otherwise be matched here and double-filled.
    // injectInto, not injectBefore — the slot IS the <ul> that lays the buttons out in a
    // row. Inserting beside it puts the <li>s in the menu div and they stack vertically.
    var quickaddSlot = card.querySelector("".concat(swatch_hover_SELECTORS.quickaddSlot, ":empty"));
    injectInto(quickaddSlot, holder.querySelector(FRAGMENTS.quickadd));
  }
}
function hydrate(target) {
  if (target.dataset.swatchState) return; // pending or already loaded
  target.dataset.swatchState = 'pending';

  // Skeleton only when the container is genuinely empty and uncached. A cache hit
  // resolves fast enough that a loader would just flash, and the option path already
  // has its swatches on screen — a skeleton there would replace visible content with
  // placeholders.
  if (!cache.has(target.dataset.swatchUrl) && !hasServerRenderedSwatches(target)) {
    target.innerHTML = skeletonMarkup();
  }
  fetchFragment(target.dataset.swatchUrl).then(function (html) {
    applyFragment(target, html);
    target.dataset.swatchState = 'loaded';
    announceLoaded(target);
  }).catch(function (error) {
    // Clear the skeleton and the flag so the next hover retries rather than
    // leaving the card stuck showing a loader that will never resolve.
    target.innerHTML = '';
    delete target.dataset.swatchState;
    console.error('[swatch-hover]', error);
  });
}

// `mouseover` fires constantly, so bail out before doing any DOM walking when the
// pointer has not actually moved to a new element.
var lastSeen = null;
function onIntent(event) {
  var node = event.target;
  if (!node || node === lastSeen) return;
  lastSeen = node;
  if (!node.closest) return;
  var card = node.closest(swatch_hover_SELECTORS.card);
  if (!card) return;
  var target = card.querySelector(swatch_hover_SELECTORS.target);
  if (target) hydrate(target);
}
function initSwatchHover() {
  if (document.body.dataset.swatchHoverReady === 'true') return;
  document.body.dataset.swatchHoverReady = 'true';

  // Delegated on document so a re-rendered grid needs no re-binding — the filter
  // handler replaces [data-products-grid] wholesale on every filter change.
  // `mouseover` rather than `mouseenter` because it bubbles; `touchstart` covers
  // .supports-touch, where the CSS uses tap-to-reveal; `focusin` covers keyboard.
  document.addEventListener('mouseover', onIntent, {
    passive: true
  });
  document.addEventListener('touchstart', onIntent, {
    passive: true
  });
  document.addEventListener('focusin', onIntent, {
    passive: true
  });
}
;// ./src/js/pages/scripts.js
/* provided dependency */ var $ = __webpack_require__(669);
function scripts_typeof(o) { "@babel/helpers - typeof"; return scripts_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, scripts_typeof(o); }
function scripts_classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function scripts_defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, scripts_toPropertyKey(o.key), o); } }
function scripts_createClass(e, r, t) { return r && scripts_defineProperties(e.prototype, r), t && scripts_defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function scripts_toPropertyKey(t) { var i = scripts_toPrimitive(t, "string"); return "symbol" == scripts_typeof(i) ? i : i + ""; }
function scripts_toPrimitive(t, r) { if ("object" != scripts_typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != scripts_typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }








 // Style B pill nav (self-inits on import)



function waitForEl(selector, callback) {
  if (document.querySelector(selector)) {
    callback();
  } else {
    setTimeout(function () {
      waitForEl(selector, callback);
    }, 100);
  }
}
var scripts = /*#__PURE__*/function () {
  function scripts() {
    scripts_classCallCheck(this, scripts);
    this.state = {};
  }
  return scripts_createClass(scripts, [{
    key: "init",
    value: function init() {
      // console.log(`Initialized ${this.constructor.name}`);

      // Global, not collection-only. swatch-hover binds three passive DELEGATED listeners on
      // document, so it covers cards that appear after load — which is every Nosto card:
      // product-grid-item-nosto fetches ?section_id=product-grid-item and replaces itself,
      // producing the same .product-grid-item markup with the same [data-swatch-url].
      //
      // Previously initialised only from pages/collection.js, so those listeners never
      // existed on the homepage, PDP, cart or 404 — where frontpage-nosto-1,
      // productpage-nosto-2/-3, cartpage-nosto-1 and notfound-nosto-1 render. Their swatch
      // containers shipped and stayed empty forever.
      //
      // Safe to call everywhere: it self-guards on document.body.dataset.swatchHoverReady,
      // the listeners are passive, and with no [data-swatch-url] on the page nothing fires.
      initSwatchHover();

      // initialize functions
      if (window.customerCountry && !sessionStorage.geCachedcountryCode) {
        console.log(window.customerCountry);
        var countryCode = window.customerCountry;
        var countryInput = document.querySelector('input[name="country_code"]');
        if (countryInput) countryInput.value = countryCode;
        var announcementForm = document.getElementById('localization_form_announcement');
        var headerForm = document.getElementById('localization_form_header');
        if (announcementForm) announcementForm.submit();
        if (headerForm) headerForm.submit();
        sessionStorage.geCachedcountryCode = countryCode;
      } else {
        this.internalPricing();
      }
      this.klaviyoForms('XBWgkx');
      // this.klaviyoForms('TY8FC7');
      this.currentOverride();
      this.sliderNav();
      this.footerOverride();
      this.scrollToSection();
      this.newTab();
      this.klaviyoModifications();
      algolia();
      this.algoliaSearch();
      this.popupForm();
      this.stickyHeader();
      this.loopReturns();
      // this.anchorNav();
      this.behavioralTracking();

      // Initialize SFS add-to-cart guard (quickview drawer)
      sfsAddToCartGuard();
      // Initialize SFS cart quantity guard (cart drawer + cart page)
      sfsCartQuantityGuard();

      // Initialize cart status announcer for accessibility
      cartStatusAnnouncer();

      // Initialize product video accessibility only when video elements exist
      if (document.querySelector('.plyr, video, [data-media-slide][data-type="video"]')) {
        productVideoAccessible();
      }
      // Initialize collection tabs carousel accessibility
      collectionTabsAccessible();
      // Initialize navigation dropdown accessibility
      navDropdownAccessible();
      // Initialize carousel accessibility (live region announcements)
      new carousel_accessibility();
      // Initialize custom back in stock modal
      if (document.getElementById('custom-bis-modal')) {
        new custom_bis_modal();
      }
    }
  }, {
    key: "algoliaSearch",
    value: function algoliaSearch() {
      var popdownToggles = document.querySelectorAll('[data-popdown-toggle]');
      popdownToggles.forEach(function (toggle) {
        toggle.addEventListener('click', function () {
          setTimeout(function () {
            var aaInput = document.querySelector('.aa-Input');
            if (aaInput) aaInput.setAttribute('placeholder', 'Search');
          }, 100);
        });
      });
      function enableSearchClick() {
        var searchInput = document.getElementById('search-input');
        if (searchInput) searchInput.removeAttribute('style');
        var searchForm = document.querySelector('.drawer__search .search__predictive__form');
        if (searchForm) {
          searchForm.addEventListener('click', function (e) {
            console.log('search input clicked...');
            var si = document.getElementById('search-input');
            if (si) si.click();
          });
        }
      }
      var searchLoaded = false;
      window.addEventListener('load', function () {
        enableSearchClick();
        searchLoaded = true;
      });
      setTimeout(function () {
        if (!searchLoaded) {
          searchLoaded = true;
          enableSearchClick();
        }
      }, 3000);
    }
  }, {
    key: "stickyHeader",
    value: function stickyHeader() {
      window.addEventListener('scroll', function (e) {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        var header = document.getElementById('shopify-section-header');
        var aaPanel = document.querySelector('.aa-Panel');
        if (scrollTop > 36) {
          if (header) header.classList.add('sticky');
          if (aaPanel) {
            aaPanel.classList.add('sticky');
            aaPanel.style.top = scrollTop + 80 + 'px';
          }
        } else {
          if (header) header.classList.remove('sticky');
          if (aaPanel) aaPanel.classList.remove('sticky');
        }
      });
    }
  }, {
    key: "popupForm",
    value: function popupForm() {
      waitForEl('button.wk-button', function () {
        if (location.pathname == '/') {
          setInterval(function () {
            wishlistPopupEvent();
          }, 1000);
        } else {
          setTimeout(function () {
            wishlistPopupEvent();
          }, 2000);
        }
        function wishlistPopupEvent() {
          var wkButtons = document.querySelectorAll('button.wk-button, .wkh-button');
          wkButtons.forEach(function (btn) {
            btn.addEventListener('click', function (e) {
              e.preventDefault();
              var customerLink = document.querySelector('a[data-customer]');
              var customer = customerLink ? customerLink.dataset.customer : null;
              if (customer == 'false' || customer === false) {
                var headerDrawer = document.querySelector('.header__drawer');
                if (innerWidth < 767 && headerDrawer && !headerDrawer.classList.contains('display-none')) {
                  var closeBtn = document.querySelector('.header__drawer .drawer__close');
                  if (closeBtn) closeBtn.click();
                }
                var popupSignup = document.querySelector('.popup-signup');
                if (popupSignup) popupSignup.classList.add('show');
              } else if (this.classList.contains('wkh-button')) {
                window.location.href = this.getAttribute('href');
              }
            });
          });
          var popupCloseBtn = document.querySelector('.popup-signup .popup-signup__close');
          if (popupCloseBtn) {
            popupCloseBtn.addEventListener('click', function () {
              var popupSignup = document.querySelector('.popup-signup');
              if (popupSignup) popupSignup.classList.remove('show');
            });
          }
          var body = document.body;
          if (body) body.classList.remove('hide-wk-floating');
        }
      });
    }
  }, {
    key: "sliderNav",
    value: function sliderNav() {
      var slideItems = document.querySelectorAll('.slider-nav .slide-item');
      slideItems.forEach(function (item) {
        item.addEventListener('click', function () {
          var id = this.dataset.anchor;
          var section = document.querySelector('div[id*="' + id + '"]');
          if (section) {
            var sectionTop = section.getBoundingClientRect().top + window.pageYOffset;
            window.scrollTo(0, sectionTop);
          }
        });
      });
      var sliderNav = document.querySelector('.slider-nav');
      if (sliderNav) {
        var mainContent = document.querySelector('body .main-content');
        if (mainContent) {
          var backToTop = document.createElement('div');
          backToTop.className = 'back-to-top';
          backToTop.innerHTML = 'Back to Top <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><mask id="path-1-inside-1_101_3" fill="white"><path d="M11.3145 6L5.65759 11.6569L0.000735774 6L5.65759 0.343141L11.3145 6Z"/></mask><path d="M5.65759 0.343141L7.07181 -1.07107L5.65759 -2.48529L4.24338 -1.07107L5.65759 0.343141ZM1.41495 7.41421L7.07181 1.75735L4.24338 -1.07107L-1.41348 4.58579L1.41495 7.41421ZM4.24338 1.75735L9.90024 7.41421L12.7287 4.58579L7.07181 -1.07107L4.24338 1.75735Z" fill="#F7F6EF" mask="url(#path-1-inside-1_101_3)"/></svg>';
          mainContent.appendChild(backToTop);
        }
        var backToTopBtn = document.querySelector('.back-to-top');
        if (backToTopBtn) {
          backToTopBtn.addEventListener('click', function () {
            window.scrollTo(0, 0);
          });
        }
      }
      var sliderNavHeight = sliderNav ? sliderNav.offsetHeight : 0;
      if (sliderNav) sliderNav.style.minHeight = sliderNavHeight + 'px';
      if (!location.href.includes('/products')) {
        window.addEventListener('scroll', function (e) {
          var el = document.querySelector('.stickyTop');
          if (!el) return;
          var isPositionFixed = window.getComputedStyle(el).position === 'fixed';
          var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          var offsetTop = el.getBoundingClientRect().top + scrollTop;
          if (scrollTop > offsetTop && !isPositionFixed) {
            el.style.position = 'fixed';
            el.style.top = '0px';
          }
          if (scrollTop < offsetTop && isPositionFixed) {
            el.style.position = 'static';
            el.style.top = '0px';
          }
          var backToTopBtn = document.querySelector('.back-to-top');
          if (scrollTop > 1000) {
            if (backToTopBtn) backToTopBtn.classList.add('active');
          } else {
            if (backToTopBtn) backToTopBtn.classList.remove('active');
          }
        });
      }
    }
  }, {
    key: "anchorNav",
    value: function anchorNav() {
      $('[data-section-type="anchor-nav"]').each(function () {
        var $nav = $('<ul class="anchor-nav"></ul>');
        var $sections = $('[data-anchor-handle]');

        // Build nav list
        $sections.each(function () {
          var handle = $(this).data('anchor-handle');
          if (handle && $.trim(handle) !== '') {
            $nav.append('<li role="link" data-handle="' + handle + '"><p>' + handle.split('-').join(' ') + '</p></li>');
          }
        });

        // append the list where you want it
        $(this).find('.anchor-nav-wrapper').append($nav);

        // Click scroll
        $nav.on('click', 'li', function () {
          var handle = $(this).data('handle');
          var $target = $sections.filter(function () {
            return $(this).data('anchor-handle') === handle;
          });
          if ($target.length) {
            $('html, body').animate({
              scrollTop: $target.offset().top - 100
            }, 500);
          }
        });

        // Scroll spy - active between this section and the next
        $(window).on('scroll', function () {
          var scrollPos = $(window).scrollTop();
          var activeHandle = null;
          $sections.each(function (i) {
            var $this = $(this);
            var thisTop = $this.offset().top;
            var nextTop = i + 1 < $sections.length ? $sections.eq(i + 1).offset().top : Number.POSITIVE_INFINITY;
            if (scrollPos >= thisTop && scrollPos < nextTop) {
              activeHandle = $this.data('anchor-handle');
              return false; // found it, break
            }
          });
          if (activeHandle) {
            $nav.find('li').removeClass('active').filter('[data-handle="' + activeHandle + '"]').addClass('active');
          }
        });
      });
    }
  }, {
    key: "footerOverride",
    value: function footerOverride() {
      var items = document.querySelectorAll('.footer .grid__item.medium-up--one-quarter:not(:first-child)');
      if (items.length > 0) {
        var wrapper = document.createElement('div');
        wrapper.className = 'grid__item medium-up--three-quarters';
        items[0].parentNode.insertBefore(wrapper, items[0]);
        items.forEach(function (item) {
          wrapper.appendChild(item);
        });
      }
    }
  }, {
    key: "currentOverride",
    value: function currentOverride() {
      waitForEl('#FreeShippingBanner', function () {
        var locForm = document.querySelector('localization-form');
        var accountLink = document.querySelector('.account-link');
        if (locForm) locForm.style.top = '-35px';
        if (accountLink) accountLink.style.top = '-35px';
        var sidebarLeft = document.querySelector('.announcement__sidebar.left');
        if (sidebarLeft) sidebarLeft.style.display = 'none';
        var announcementSection = document.getElementById('shopify-section-announcement');
        var outerWrapper = announcementSection ? announcementSection.querySelector('.announcement__outer-wrapper') : null;
        if (announcementSection) {
          announcementSection.style.height = '0';
          announcementSection.style.minHeight = '0';
          announcementSection.style.padding = '0';
        }
        if (outerWrapper) {
          outerWrapper.style.height = '0';
          outerWrapper.style.minHeight = '0';
          outerWrapper.style.padding = '0';
        }
      });
    }
  }, {
    key: "internalPricing",
    value: function internalPricing() {
      var SHOW_CCPA_BANNER = false;
      var _shopifyRoot = window.Shopify && Shopify.routes && Shopify.routes.root || '/';
      fetch(_shopifyRoot + 'browsing_context_suggestions.json?country[enabled]=true').then(function (r) {
        return r.ok ? r.json() : null;
      }).then(function (response) {
        if (!response || !response.detected_values || !response.detected_values.country) return;
        var countryCode = response.detected_values.country.handle;
        if (countryCode == 'US') {
          // Force the storefront to US when it isn't already, mirroring the non-US
          // correction in the else branch. The country_code input is rendered with
          // value="", so a correctly-US visitor reads
          // 'US' here and skips the submit — no reload/flash for normal US traffic. The
          // != 'US' + empty-geCachedcountryCode guards make this run at most once and
          // prevent a reload loop: after the submit reloads, country_code is 'US' and the
          // cache is set, so the condition is false on the next pass.
          var usCountryInput = document.querySelector('input[name="country_code"]');
          var usCurrentCountryCode = usCountryInput ? usCountryInput.value : '';
          if (usCurrentCountryCode != 'US' && !sessionStorage.geCachedcountryCode) {
            if (usCountryInput) usCountryInput.value = 'US';
            var usAnnouncementForm = document.getElementById('localization_form_announcement');
            var usHeaderForm = document.getElementById('localization_form_header');
            if (usAnnouncementForm) usAnnouncementForm.submit();
            if (usHeaderForm) usHeaderForm.submit();
          }
          sessionStorage.geCachedcountryCode = 'US';

          // hide cookie preference for US
          if (SHOW_CCPA_BANNER) {
            var style = document.createElement('style');
            style.textContent = '#pandectes-dsr-container #pd-consent { display: none !important; }';
            document.head.appendChild(style);
            var cookiePreferences = document.querySelector('a[href="#reopenBanner"]');
            if (cookiePreferences) cookiePreferences.style.display = 'none';
          }
        } else {
          var countryLink = document.querySelector('a.country-code[data-value="' + countryCode + '"]');
          if (countryLink) {
            var currentCountryInput = document.querySelector('input[name="country_code"]');
            var currentCountryCode = currentCountryInput ? currentCountryInput.value : '';
            var disclosureEl = document.querySelector('.disclosure__button');
            if (!(disclosureEl && disclosureEl.textContent.includes('United States'))) {
              document.querySelectorAll('.ge-hide').forEach(function (el) {
                el.style.display = 'none';
              });
            }
            if (currentCountryCode != countryCode && !sessionStorage.geCachedcountryCode) {
              // submit if country code don't match
              if (currentCountryInput) currentCountryInput.value = countryCode;
              var announcementForm = document.getElementById('localization_form_announcement');
              var headerForm = document.getElementById('localization_form_header');
              if (announcementForm) announcementForm.submit();
              if (headerForm) headerForm.submit();
            }
            sessionStorage.geCachedcountryCode = countryCode;
          }
          var linksToHide = ['a[href="/pages/do-not-sell-my-information"]'];
          linksToHide.forEach(function (selector) {
            document.querySelectorAll(selector).forEach(function (link) {
              if (link.parentElement) {
                var prevSibling = link.parentElement.previousElementSibling;
                if (prevSibling) {
                  var pipeSpan = prevSibling.querySelector('span');
                  if (pipeSpan && pipeSpan.textContent.trim() === '|') {
                    pipeSpan.style.display = 'none';
                  }
                }
                link.parentElement.style.display = 'none';
              }
            });
          });
          var rAccount = document.querySelector('.r-account');
          var rLogin = document.querySelector('.r-login');
          if (rAccount) rAccount.style.display = 'none';
          if (rLogin) rLogin.style.display = 'none';
          var sidebarLeft = document.querySelector('.announcement__sidebar.left');
          if (sidebarLeft) sidebarLeft.remove();
        }
      }).catch(function (err) {
        console.error('IP info fetch error:', err);
      });
      var disclosureBtn = document.querySelector('.disclosure__button');
      var disclosureText = disclosureBtn ? disclosureBtn.textContent.trim() : '';
      if (!disclosureText.includes('United States') && location.pathname.includes('/products')) {
        var buttonActions = document.querySelector('.pv__button-actions');
        if (buttonActions) {
          var span = document.createElement('span');
          span.style.cssText = 'color:#6a7a57;display:block;padding-top:8px; font-size: 12px;background:#F7F6EF;';
          span.innerHTML = '<b style="font-weight:700;">Express shipping</b> & <b style="font-weight:700;">alternate payment</b> options available. <br> Duties & taxes included at checkout, we guarantee no additional charges on delivery.';
          buttonActions.parentNode.insertBefore(span, buttonActions.nextSibling);
        }
      }
    }
  }, {
    key: "klaviyoForms",
    value: function klaviyoForms(formId) {
      var config = {
        cls: {
          signUpOverlay: 'js-sing-up-overlay',
          phoneNumberMessage: 'js-phone-number-message',
          successClass: 'klaviyo-success',
          successFormMobileClass: 'klaviyo-success-form-mobile',
          singUpClose: 'signup__overlay__close'
        }
      };
      var signUpOverlay = document.querySelector('.' + config.cls.signUpOverlay);
      var klaviyoForm = document.querySelector('.klaviyo-form-' + formId);
      var signUpClose = document.querySelector('.' + config.cls.singUpClose);
      function init() {
        addEvents();
      }
      function addEvents() {
        window.addEventListener('klaviyoForms', showSuccessCopy);
      }

      // show success copy
      function showSuccessCopy(e) {
        if (e.detail.type === 'submit' && e.detail.formId === formId) {
          if (klaviyoForm) klaviyoForm.style.display = 'none';
          if (formId === 'TY8FC7') {
            if (signUpOverlay) signUpOverlay.classList.add(config.cls.successFormMobileClass);
          } else if (formId === 'XgxH9G') {
            if (signUpClose) signUpClose.click();
          } else {
            if (signUpOverlay) signUpOverlay.classList.add(config.cls.successClass);
          }
        }
      }

      // return
      return init();
    }
  }, {
    key: "scrollToSection",
    value: function scrollToSection() {
      if (location.pathname.includes('pages/faq')) {
        if (location.hash.includes('customer-service')) {
          var lastSection = document.querySelector('main .shopify-section:last-child');
          if (lastSection) {
            var targetTop = lastSection.getBoundingClientRect().top + window.pageYOffset - 140;
            window.scrollTo({
              top: targetTop,
              behavior: 'smooth'
            });
          }
        }
      }
    }
  }, {
    key: "searchHandle",
    value: function searchHandle() {
      if (innerWidth > 768) {
        var searchBtns = document.querySelectorAll('.header__search__button a[href="/search"]');
        searchBtns.forEach(function (btn) {
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            if (this.classList.contains('active')) {
              var aaInput = document.querySelector('.aa-MainContainer input');
              var value = aaInput ? aaInput.value : '';
              window.location.href = '/search?q=' + value;
            } else {
              this.classList.add('active');
              var container = this.nextElementSibling;
              if (container && container.classList.contains('search-input-container')) {
                container.classList.add('active');
              }
              var aaInput = document.querySelector('.aa-MainContainer input');
              if (aaInput) aaInput.focus();
            }
          });
        });
      } else {
        var mobileSearchBtns = document.querySelectorAll('.header__search__button a[href="/search"], #header-search svg');
        mobileSearchBtns.forEach(function (btn) {
          btn.addEventListener('click', function (e) {
            e.preventDefault();
            var aaInput = document.querySelector('.aa-MainContainer input');
            if (aaInput) aaInput.click();
          });
        });
      }
    }
  }, {
    key: "newTab",
    value: function newTab() {
      var links = document.querySelectorAll('a');
      links.forEach(function (a) {
        var hrefMod = a.getAttribute('href');
        var check = new RegExp(window.location.host);
        var http = new RegExp('http');
        if (hrefMod === '/') {
          a.setAttribute('target', '');
        } else if (!http.test(hrefMod)) {
          if (location.pathname != '/account') {
            a.setAttribute('target', '');
          }
        } else if (!check.test(hrefMod) && !a.classList.contains('not-blank')) {
          a.setAttribute('target', '_blank');
        }
      });
    }
  }, {
    key: "klaviyoModifications",
    value: function klaviyoModifications() {
      var klaviyoId = location.origin == 'https://frank-and-eileen-staging.myshopify.com' ? 'VigJ2h' : 'Yb8rZN';
      waitForEl('.klaviyo-form-' + klaviyoId + ' button.needsclick', function () {
        var btn = document.querySelector('.klaviyo-form-' + klaviyoId + ' button');
        if (btn) {
          btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="36.864" height="15.225" viewBox="0 0 36.864 15.225"><g data-name="Layer 2"><g  data-name="Layer 1"><path class="cls-1" fill="#fff" d="M35.867,6.117c-1.637-.844-4.6-.266-6.333-.184-3.677.174-7.348.457-11.023.669-1.816.1-3.632.2-5.45.251-.472.013-1.2.093-1.979.143a6.393,6.393,0,0,1,.583-1.207c.738-1.158,1.773-2.523,1.829-3.953a.749.749,0,0,0-.014-.727A1.314,1.314,0,0,0,13.389.9c0-.011,0-.021,0-.031a.788.788,0,0,0-.233-.354.969.969,0,0,0-.122-.178A1.249,1.249,0,0,0,11.5.2a.908.908,0,0,0-.109.074c-.027.024-.062.032-.087.059l-.053.057c-.009.01-.023.015-.032.026A.29.29,0,0,0,11.2.446L11,.659a1.257,1.257,0,0,0-.155,1.5.953.953,0,0,0,.223.355C8.578,5.445,4.2,6.833.581,7.433c-.906.15-.689,1.629.216,1.6A11.744,11.744,0,0,1,7.94,11.39C8.462,11.9,9,12.437,9.482,13.006a5.77,5.77,0,0,1,.312.523,1.077,1.077,0,0,0-.217.429.807.807,0,0,0,.07,1.033.867.867,0,0,0,.895.179,1,1,0,0,0,.3-.017.941.941,0,0,0,.529-.39.685.685,0,0,0,.349-.773.753.753,0,0,0-.04-.694,7.444,7.444,0,0,1-1.052-3.867c.891-.038,1.75-.12,2.43-.139,2.973-.082,5.944-.275,8.912-.464,2.83-.18,5.661-.385,8.5-.5.961-.038,1.925-.079,2.887-.059.258.005.659.089.96.07a1.062,1.062,0,0,0,1.663.566C37.16,8.062,37.2,6.8,35.867,6.117Zm-26-.248a.778.778,0,0,0-.024-.124c.068-.046.133-.1.2-.143C9.978,5.691,9.92,5.78,9.862,5.869ZM8.9,10.047c.029-.027.059-.054.087-.084.007.065.014.128.022.193Z"></path></g></g></svg>';
        }
      });
    }
  }, {
    key: "loopReturns",
    value: function loopReturns() {
      waitForEl('#loop-onstore', function () {
        var drawerContent = document.querySelector('.drawer__content');
        if (drawerContent) drawerContent.style.height = '95%';
      });
    }
  }, {
    key: "behavioralTracking",
    value: function behavioralTracking() {
      function datalLayerPush(sectionName, sectionElementName, sectionOrder, url) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'behavioral_tracking',
          section_name: sectionName,
          section_element_name: sectionElementName,
          section_order_on_page: sectionOrder,
          linkUrl: url
        });
      }

      // programmatically add data-section-name to specific links
      var carouselBtns = document.querySelectorAll('.homepage-carousel button.flickity-button');
      carouselBtns.forEach(function (btn) {
        btn.setAttribute('data-section-name', 'new_arrivals_product_slider,new_arrivals_product_slider_arrows');
      });
      waitForEl('.klaviyo-form', function () {
        var klaviyoBtn = document.querySelector('.klaviyo-form button.needsclick');
        if (klaviyoBtn) klaviyoBtn.setAttribute('data-section-name', 'footer,newsletter');
      });

      // wishlist tracking
      waitForEl('product-grid-item button.wk-button', function () {
        var wkButtons = document.querySelectorAll('product-grid-item button.wk-button');
        wkButtons.forEach(function (btn) {
          btn.setAttribute('data-section-name', 'product_card,favorite_icon');
        });
        if (location.href.includes('/products/')) {
          // yotpo review button on pdp
          var reviewButton = document.querySelector('.product__inner .yotpo-sr-bottom-line-button');
          if (reviewButton) {
            reviewButton.setAttribute('data-section-name', 'product_details,reviews');
          }

          // renumber swatches - pdp
          var swatches = document.querySelectorAll('.product__inner .config__btn.swatch');
          swatches.forEach(function (swatch, index) {
            swatch.setAttribute('data-section-name', 'product_details,product_color_' + Number(index + 1));
          });

          // whats my size button - pdp
          var sizeButton = document.querySelector('.wair-launch-btn');
          if (sizeButton) {
            sizeButton.setAttribute('data-section-name', 'product_details,whats_my_size');
          }
          // add to wishlist button - pdp
          var wishlistButton = document.querySelector('wishlist-button-block button');
          if (wishlistButton) {
            wishlistButton.setAttribute('data-section-name', 'product_details,add_to_wishlist');
          }
          // yotpo reviews summary - pdp
          var yotpoReviewsSummary = document.querySelector('#yotpo-reviews-main-widget #yotpo-summary');
          if (yotpoReviewsSummary) {
            yotpoReviewsSummary.setAttribute('data-section-name', 'customer_reviews_summary,see_reviews_summary');
          }

          //yotpo reviews rating - pdp
          var yotpoReviewsRating = document.querySelector('#yotpo-reviews-main-widget .yotpo-star-distribution-row-wrapper');
          if (yotpoReviewsRating) {
            yotpoReviewsRating.setAttribute('data-section-name', 'customer_reviews_summary,review_rating');
          }

          // yotpo write a review - pdp
          var yotpoWriteReview = document.querySelector('#yotpo-reviews-main-widget .yotpo-new-review-btn');
          if (yotpoWriteReview) {
            yotpoWriteReview.setAttribute('data-section-name', 'customer_reviews_summary,write_a_review');
          }

          // yotpo popular topics - pdp
          var yotpoPopularTopics = document.querySelector('#yotpo-reviews-main-widget .yotpo-smart-topic-filter');
          if (yotpoPopularTopics) {
            yotpoPopularTopics.setAttribute('data-section-name', 'customer_reviews_filters,popular_topics');
          }

          // yotpo popular topics see more - pdp
          var yotpoPopularTopicsSeeMore = document.querySelector('#yotpo-reviews-main-widget .yotpo-smart-topics-see-more-label');
          if (yotpoPopularTopicsSeeMore) {
            yotpoPopularTopicsSeeMore.setAttribute('data-section-name', 'customer_reviews_filters,popular_topics_see_more');
          }

          // yotpo sort by - pdp
          var yotpoSortBy = document.querySelector('#yotpo-reviews-main-widget .yotpo-sorting-filter-container');
          if (yotpoSortBy) {
            yotpoSortBy.setAttribute('data-section-name', 'customer_reviews_sort,sort_by');
          }

          // yotpo filter name pdp
          var yotpoFilterName = document.querySelector('#yotpo-reviews-main-widget .yotpo-filters-top-panel');
          if (yotpoFilterName) {
            Array.from(yotpoFilterName.children).forEach(function (filter, index) {
              filter.setAttribute('data-section-name', 'customer_reviews_filters,filter_name_0' + (index + 1));
            });
          }
        }

        //section names
        var sectionNames = document.querySelectorAll('[data-section-name]');
        sectionNames.forEach(function (section) {
          var sectionNameAttr = section.getAttribute('data-section-name');
          var sectionName = sectionNameAttr.split(',')[0].trim();
          var sectionElementName = sectionNameAttr.split(',')[1].trim();
          var url = section.href ? section.href : 'no url';
          var sectionOrder = 1;
          section.addEventListener('click', function () {
            // special treatment for specific sections
            if (sectionName == 'hero') {
              var sectionImage = section.closest('[data-section-type="hero"]');
              var sectionImages = document.querySelectorAll('[data-section-type="hero"]');
              var index = Array.from(sectionImages).indexOf(sectionImage);
              if (index > 0) {
                sectionName = 'banner_0' + (index + 1);
                sectionElementName = 'banner_0' + (index + 1) + '_' + sectionElementName.split('_')[1];
              }
            }
            if (sectionName != 'header') {
              var parentSection = section.closest('.shopify-section');
              var parentSections = document.querySelectorAll('.shopify-section');
              var index = Array.from(parentSections).indexOf(parentSection);
              sectionOrder = index;
            }
            datalLayerPush(sectionName, sectionElementName, sectionOrder, url);
          });
        });
      });
    }
  }]);
}();
;// ./src/js/components/gorgias-deferred.js
/**
 * Deferred Gorgias chat.
 *
 * Gorgias' embed downloads ~589 KB of JavaScript across 22 files on every pageview to
 * render a single button. This holds that back: snippets/gorgias-chat-deferred.liquid
 * renders a look-alike button, and the real loader is injected only when someone presses
 * it. Measured on /collections/fall-clothes, that is ~17% of the page's total transfer and
 * 6% of its 500 requests removed from every session that never opens chat.
 *
 * It does NOT reduce Total Blocking Time. Gorgias renders inside a cross-origin iframe, so
 * its work already sits in another process and never showed up in the page's Long Animation
 * Frame attribution. The win here is bytes, mobile data, and contention — not TBT.
 *
 * Handoff, per Gorgias' own bundle-loader:
 *
 *   window.GorgiasChat is a Proxy installed synchronously by the loader script. Every
 *   property except `init` and `resolve` THROWS until the chat is ready, so `init()` — which
 *   returns a promise — is the only supported way to wait.
 *
 *     GorgiasChat.init().then(() => GorgiasChat.open())
 *
 *   The loader also self-guards against double injection ("Another chat was detected"), so a
 *   duplicate <script> is inert rather than harmful. We still only inject once.
 *
 * Docs: https://docs.gorgias.com/gorgias-chat/advanced-customization-new-chat
 */

var gorgias_deferred_SELECTORS = {
  placeholder: '[data-gorgias-placeholder]'
};
var LOADER_SRC = 'https://config.gorgias.chat/bundle-loader/shopify/frankandeileen.myshopify.com';

// Gorgias writes this the moment the widget initialises, and it is session-scoped. Its
// presence means "this shopper already opened chat during this visit" — they may be
// mid-conversation, so on later pages we load eagerly rather than making them find the
// button again to get their thread back. localStorage keys (gorgias.guest-id) are NOT used
// for this: those persist forever and would make anyone who ever chatted pay on every visit.
var SESSION_KEY = 'gorgias.session-id';

// If the bundle never resolves (blocked, offline, third-party outage) give the button back
// so the shopper can retry instead of watching a spinner forever.
var LOAD_TIMEOUT_MS = 12000;
var injected = false;

/** Session storage throws in some privacy modes; absence is the safe answer. */
function hasLiveChatSession() {
  try {
    return window.sessionStorage.getItem(SESSION_KEY) !== null;
  } catch (err) {
    return false;
  }
}

/**
 * Inject Gorgias' loader once and resolve when the chat API is genuinely usable.
 * Repeat calls return the same promise rather than appending another script tag.
 */
var readyPromise = null;
function loadGorgias() {
  if (readyPromise) return readyPromise;
  readyPromise = new Promise(function (resolve, reject) {
    if (!injected) {
      injected = true;
      var script = document.createElement('script');
      script.src = LOADER_SRC;
      script.async = true;
      script.onerror = function () {
        return reject(new Error('Gorgias loader failed to load'));
      };
      document.body.appendChild(script);
    }

    // The loader defines window.GorgiasChat synchronously, but the <script> above is async,
    // so poll briefly for it to exist before asking it for init().
    var started = Date.now();
    (function waitForApi() {
      if (window.GorgiasChat && typeof window.GorgiasChat.init === 'function') {
        window.GorgiasChat.init().then(resolve, reject);
        return;
      }
      if (Date.now() - started > LOAD_TIMEOUT_MS) {
        reject(new Error('Gorgias API did not appear'));
        return;
      }
      window.setTimeout(waitForApi, 60);
    })();
  });
  return readyPromise;
}

/** The real widget renders its own button, so ours has to go or there will be two. */
function removePlaceholder(button) {
  if (button && button.parentNode) button.parentNode.removeChild(button);
}
function onClick(button) {
  // Ignore repeat presses while the bundle is in flight.
  if (button.getAttribute('aria-busy') === 'true') return;
  button.setAttribute('aria-busy', 'true');
  button.classList.add('is-loading');
  var failed = window.setTimeout(function () {
    button.setAttribute('aria-busy', 'false');
    button.classList.remove('is-loading');
  }, LOAD_TIMEOUT_MS);
  loadGorgias().then(function () {
    window.clearTimeout(failed);
    // Without this the shopper's click is swallowed: the real widget appears closed and
    // they have to press it a second time.
    window.GorgiasChat.open();
    removePlaceholder(button);
  }).catch(function () {
    window.clearTimeout(failed);
    button.setAttribute('aria-busy', 'false');
    button.classList.remove('is-loading');
  });
}
function initGorgiasDeferred() {
  var button = document.querySelector(gorgias_deferred_SELECTORS.placeholder);
  if (!button) return;
  if (hasLiveChatSession()) {
    // Already chatting this session — bring the real widget straight back, closed, so an
    // in-progress conversation is one click away and any unread reply badge shows.
    loadGorgias().then(function () {
      return removePlaceholder(button);
    }).catch(function () {
      button.hidden = false;
    });
    return;
  }
  button.hidden = false;
  button.addEventListener('click', function () {
    return onClick(button);
  });
}
;// ./src/app.js



document.addEventListener('DOMContentLoaded', function () {
  var app = new scripts();
  app.init();
  initGorgiasDeferred();
});
/******/ })()
;